<template>
  <div class="container-fluid">
    <div v-if="loading_i" class="loading-state">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row">
      <div class="col-12 mb-4">
        <ul id="bmTab" class="nav nav-tabs dashboard-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              id="tab1-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab1" type="button" role="tab"
              aria-controls="tab1" aria-selected="true" @click="onClickTab('1')">
              {{ $t("content.overview") }}
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button
              id="tab3-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab3" type="button" role="tab"
              aria-controls="tab3" aria-selected="false" :disabled="shop_seleted === '0'" @click="onClickTab('3')">
              {{ $t("content.detail") }}
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button
              id="tab2-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2" type="button" role="tab"
              aria-controls="tab2" aria-selected="false" :disabled="shop_seleted === '0'" @click="onClickTab('2')">
              {{ $t("content.repredeint") }}
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button
              id="tab4-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab4" type="button" role="tab"
              aria-controls="tab4" aria-selected="false"  :disabled="shop_seleted === '0'" @click="onClickTab('4')">
              {{ $t("content.tkdue") }}
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              id="tab5-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab5" type="button" role="tab"
              aria-controls="tab5" aria-selected="false" :disabled="shop_seleted === '0'" @click="onClickTab('5')">
              งานค้างทั้งหมด
            </button>
          </li>
        </ul>

         <div id="bmTabContent" class="tab-content">
           <div id="tab1" class="tab-pane fade" role="tabpanel" aria-labelledby="tab1-tab">
            <DashboardOverview
              :data="dataInfo" :line-count="Number(numOfLineCustomer) || 0"
              :line-loading="perShopLoading" :line-failed="perShopFailed.length > 0"
              :busy="overviewInfoLoading" :ready="loading" :error="overviewError"
              :selected="!!overviewGroup || (!!shop_seleted && shop_seleted !== '0')"
              :updated-at="overviewUpdatedAt" :from="start_date" :to="end_date"
              @search="applyOverviewRange" @retry="searchDashboardInfo"
              @report="onOverviewReport"
              @history="goToHistory"
              @otp="value => goToHistory_detail(value, '', '')">
              <template #scope><shop-scope-select
                :model-value="overviewGroup" :shop-name="selectedShopName"
                :disabled="overviewInfoLoading"
                @update:model-value="onOverviewGroupChange" /></template>
              <template #notice><group-loading-notice
                v-if="overviewGroup || perShopFailed.length" :active="perShopLoading"
                :title="t('content.shopgrp_loading', { n: perShopTotal })"
                :done="perShopDone" :total="perShopTotal" :failed="perShopFailed"
                @retry="loadOverviewPerShop" /></template>
            </DashboardOverview>
            <material-button v-show="false" id="userWorkModalShow" data-bs-toggle="modal" data-bs-target="#detailUserWorkModal" />
            <div
          id="detailUserWorkModal" class="modal fade"  aria-labelledby="detailUserWorkLabel"
          aria-hidden="true">
         <div class="modal-dialog modal-xl modal-dialog-centered" style="max-width:1240px;">
            <div class="modal-content">
              <div class="modal-header">
                <h1 id="detailUserWorkModalLabel" class="modal-title fs-5">
                  <span v-if="userq === 'Q01'">
                    {{ $t("content.workQ01") }} : {{ formatNumberString(num_q01) }}
                  </span>
                  <span v-else-if="userq === 'Q02'">
                    {{ $t("content.workQ02") }} : {{ formatNumberString(num_q02) }}
                  </span>
                  <span v-else-if="userq === 'Q03'">
                    {{ $t("content.workQ03") }} : {{ formatNumberString(num_q03) }}
                  </span>
                  <span v-else-if="userq === 'Q04'">
                    {{ $t("content.workQ04") }} : {{ formatNumberString(num_q04) }}
                  </span>
                  <span v-else-if="userq === 'QPAY'">
                    {{ $t("content.workQpay") }} : {{ formatNumberString(num_pay) }}
                  </span>
                </h1>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>
              <div class="modal-body">
                <table v-if="userq !== 'QPAY'" class="table table-sm table-borderless">
                  <tbody>
                    <tr>
                      <td class="text-dark">
                        <h6><b>
                            #
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark">
                          <h6><b>
                              {{ $t("content.time") }}
                            </b>
                          </h6>
                      </td>
                      <td class="text-dark">
                        <h6><b>
                            {{ $t("content.jobId") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark">
                        <h6><b>
                            {{ $t("content.item") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark">
                        <h6><b>
                            {{ $t("content.cname") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark">
                        <h6><b>
                            {{ $t("content.refnumberold") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark">
                        <h6><b>
                            {{ $t("content.refnumbernew") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark">
                        <h6><b>
                            {{ $t("content.amnanalysval") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark">
                        <h6><b>
                            {{ $t("content.gpay") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark text-center">
                        <h6><b>
                            {{ $t("content.amnassetdetail") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark text-center">
                        <h6><b>
                            {{ $t("content.amnassetimage") }}
                          </b>
                        </h6>
                      </td>
                      <td class="text-dark text-center">
                        <h6><b>
                            {{ $t("content.amnlastmaker") }}
                          </b>
                        </h6>
                      </td>
                      
                    </tr>
                    <tr v-for="(row, index) in list_userq" :key="index">
                      <td class="text-md text-dark">
                        {{ formatNumberString(index + 1) }}
                      </td>
                      <td class="text-md text-dark">
                          {{ format_time(row.startTime) }}
                      </td>
                      <td class="text-md text-dark">
                          {{ row.jobId }}
                      </td>
                      <td class="text-md text-dark">
                        <span v-if="row.migration"> 
                          {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }})
                        </span>
                        <span v-else>
                          {{ checkTransaction(row.type) }}
                        </span>
                      </td>
                      <td class="text-md text-dark">
                        <span v-if="row.changeName">
                          {{ row.customerName }}
                        </span>
                        <span v-else>
                          {{ row.tkCustomerName }}
                        </span>
                      </td>
                      <td class="text-md text-dark">
                        {{ row.prevRefNumber }}
                      </td>
                      <td class="text-md text-dark">
                        {{ row.refNumber }}
                      </td>
                      <td class="text-md text-dark">
                        <span v-if="row.type !== 'PAYMENT'">
                          {{ formatNumberDecimalString(row.newPawnValue) }}
                        </span>
                      </td>
                      <td class="text-md text-dark">
                        <span v-if="row.type !== 'PAYMENT'">
                          <span v-if="row.totalPay !== 0" style="color:red">
                            {{ formatNumberDecimalString(row.totalPay) }}
                          </span>
                          <span v-else-if="row.totalReceive !== 0" style="color:green">
                            {{ formatNumberDecimalString(row.totalReceive) }}
                          </span>
                          <span v-else>
                            {{ formatNumberDecimalString(row.totalReceive) }} 
                          </span>
                        </span>
                      </td>
                      <td class="text-md text-dark text-center">
                        <span v-if="row.type !== 'PAYMENT'">
                          <material-button
color="info" variant="outline" class="rounded-circle"
                              :title="t('buttons.seed')" @click="getCollecteral(row.workCaseUid , 'coll')">
                              <i class="material-icons material-symbols-outlined">manage_search</i>
                          </material-button>
                        </span>
                      </td>
                      <td class="text-md text-dark text-center">
                         <span v-if="row.type !== 'PAYMENT'">
                          <material-button
color="success" variant="outline" class="rounded-circle"
                              :title="t('content.viewimg')" @click="getCollecteral(row.workCaseUid, 'img')">
                              <i class="material-icons material-symbols-outlined">photo_library</i>
                          </material-button>
                        </span>
                      </td>
                      <td class="text-md text-info text-center">
                        <span v-if="row.ownerUid !== '0'">
                          {{ row.ownerName }}
                        </span>
                        <span v-else style="color:red;">
                          -
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                  <table v-else class="table table-sm table-borderless">
                    <tbody>
                      <tr>
                        <td class="text-dark">
                          <h6><b>
                              #
                            </b>
                          </h6>
                        </td>
                        <td class="text-dark">
                          <h6><b>
                              {{ $t("content.time") }}
                            </b>
                          </h6>
                        </td>
                        <td class="text-dark">
                          <h6><b>
                              {{ $t("content.jobId") }}
                            </b>
                          </h6>
                        </td>
                        <td class="text-dark">
                          <h6><b>
                              {{ $t("content.cname") }}
                            </b>
                          </h6>
                        </td>
                        <td class="text-dark">
                          <h6><b>
                              {{ $t("content.amntotalval") }}
                            </b>
                          </h6>
                        </td>
                        <td class="text-dark text-center">
                          <h6><b>
                              {{ $t("content.amnlastmaker") }}
                            </b>
                          </h6>
                        </td>
                      </tr>
                      <tr v-for="(row, index) in list_pay" :key="index">
                        <td class="text-md text-dark">
                          {{ formatNumberString(index + 1) }}
                        </td>
                        <td class="text-md text-dark">
                          {{ format_time(row.startTime) }}
                        </td>
                        <td class="text-md text-dark">
                          {{ row.jobId }}
                        </td>
                        <td class="text-md text-dark">
                          {{ row.customerName }}
                        </td>
                        <td class="text-md text-dark">
                          <span v-if="row.roundTotalPay !== 0" style="color:red">
                            {{ formatNumberDecimalString(row.roundTotalPay) }}
                          </span>
                          <span v-else-if="row.roundTotalReceive !== 0" style="color:green">
                            {{ formatNumberDecimalString(row.roundTotalReceive) }}
                          </span>
                          <span v-else>
                            {{ formatNumberDecimalString(row.roundTotalReceive) }}
                          </span>
                        </td>
                        <td class="text-md text-info text-center">
                          <span v-if="filterUserOwner(row.workItemUid) !== ''">
                            {{ filterUserOwner(row.workItemUid)}}
                          </span>
                          <span v-else style="color:red;">
                            -
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
              </div>
            </div>
          </div>
        </div>
          </div>


         <div id="tab2" class="tab-pane fade" role="tabpanel" aria-labelledby="tab2-tab">
            <div class="row">
              <div class="col-12 mb-3">
                <div class="card h-100 mt-3">
                  <div class="card-header mb-0">
                    <h5>{{ $t("content.repredeint") }}</h5>
                  </div>
                  <div class="card-body pt-0">
                    <div class="row">
                      <div class="col-lg-4 me-3">
                        <span class="form-label m-0">{{ $t("content.sdate") }}</span>
                        <div class="d-inline-block mx-4">
                          <VueDatePicker
v-model="start_dater" :format="format" auto-apply :teleport="true"
                            :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                            :clearable="false" :text-input="textInputOptions" fluid />
                        </div>
                      </div>
                      <div class="col-lg-4 me-3">
                        <span class="form-label m-0">{{ $t("content.edate") }}</span>
                        <div class="d-inline-block mx-4">
                          <VueDatePicker
v-model="end_dater" :format="format" auto-apply :teleport="true"
                            :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                            :clearable="false" :text-input="textInputOptions" fluid />
                        </div>
                      </div>
                      <div class="col-lg-2 me-3">
                        <span class="form-label m-0"></span>
                        <div class="d-inline-block mx-4">
                          <material-button
id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                            :disabled="start_dater > end_dater" @click="loadRedeemReportApi">
                            <i class="material-icons material-symbols-outlined">search</i>
                            {{ search }}
                          </material-button>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="table-responsive">
                        <table class="table table-flush">
                          <thead class="thead-light">
                            <tr>
                              <th>{{ $t("content.months") }}</th>
                              <th>{{ $t("content.be_year") }}</th>
                              <th>{{ $t("content.numamount") }}</th>
                              <th>{{ $t("content.amount") }}</th>
                              <th>{{ $t("content.amnrealprofit") }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, index) in reportlist" :key="index">
                              <td class="text-sm font-weight-normal">
                                {{ filterMonths(row.month) }}
                              </td>
                              <td class="text-sm font-weight-normal">
                                {{ setyears(row.year) }}
                              </td>
                              <td class="text-sm font-weight-normal">
                                {{ formatNumberString(row.ticket) }}
                              </td>
                              <td class="text-sm font-weight-normal">
                                {{ formatNumberDecimalString(row.pawnValue) }}
                              </td>
                              <td class="text-sm font-weight-normal">
                                {{ formatNumberDecimalString(row.interest) }}
                              </td>
                            </tr>
                            <tr v-if="reportlist.length === 0">
                              <td colspan="10" class="text-sm font-weight-normal">
                                <p style="text-align: center">No Record Found</p>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr v-if="reportlist.length > 0">
                              <td class="text-lg font-weight-bold text-end text-center" colspan="2">
                                <span v-if="reportlist.length > 0">
                                  <b>{{ $t("content.gtotal") }}</b>
                                </span>
                              </td>
                              <td class="text-lg font-weight-bold">
                                <span v-if="reportlist.length > 0">
                                  <b>{{ formatNumberString(totalTicket) }}</b>
                                </span>
                              </td>
                              <td class="text-lg font-weight-bold">
                                <span v-if="reportlist.length > 0">
                                  <b>{{ formatNumberDecimalString(totalPawnValue) }}</b>
                                </span>
                              </td>
                              <td class="text-lg font-weight-bold">
                                <span v-if="reportlist.length > 0">
                                  <b>{{ formatNumberDecimalString(totalInterest) }}</b>
                                </span>
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="tab3" class="tab-pane fade" role="tabpanel" aria-labelledby="tab3-tab">
            <div class="row">
              <div class="col-12 mb-3">
                <div class="card mt-3">
                  <div class="card-header mb-0 d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <h5 class="mb-0">{{ $t("content.detail") }}</h5>
                    <div class="d-flex gap-2">
                      <material-button
                        :color="detailViewMode === 'visual' ? 'primary' : 'secondary'"
                        :variant="detailViewMode === 'visual' ? 'fill' : 'outline'"
                        size="sm" class="m-0 text-nowrap"
                        @click="setDetailViewMode('visual')">
                        <i class="material-icons material-symbols-outlined">insert_chart</i>
                        รูปภาพ
                      </material-button>
                      <material-button
                        :color="detailViewMode === 'table' ? 'primary' : 'secondary'"
                        :variant="detailViewMode === 'table' ? 'fill' : 'outline'"
                        size="sm" class="m-0 text-nowrap"
                        @click="setDetailViewMode('table')">
                        <i class="material-icons material-symbols-outlined">table_rows</i>
                        ตาราง
                      </material-button>
                    </div>
                  </div>
                  <div class="card-body pt-0">
                    <div class="row">
                      <div class="col-lg-4 me-3">
                        <span class="form-label m-0">{{ $t("content.sdate") }}</span>
                        <div class="d-inline-block mx-4">
                          <VueDatePicker
                            v-model="start_datet" :format="format" auto-apply :teleport="true"
                            :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                            :clearable="false" :text-input="textInputOptions" fluid />
                        </div>
                      </div>
                      <div class="col-lg-4 me-3">
                        <span class="form-label m-0">{{ $t("content.edate") }}</span>
                        <div class="d-inline-block mx-4">
                          <VueDatePicker
                            v-model="end_datet" :format="format" auto-apply :teleport="true"
                            :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                            :clearable="false" :text-input="textInputOptions" fluid />
                        </div>
                      </div>
                      <div class="col-lg-2 me-3">
                        <span class="form-label m-0"></span>
                        <div class="d-inline-block mx-4">
                          <material-button
                            id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                            :disabled="start_datet > end_datet" @click="searchTransactionsInfo">
                            <i class="material-icons material-symbols-outlined">search</i>
                            {{ search }}
                          </material-button>
                        </div>
                      </div>
                    </div>

                    <div v-if="summaryDetail !== null" class="summary-row mt-3 me-3">
                      <div class="d-flex justify-content-between align-items-center gap-3">
                        
                        <!-- รายการที่ 1: จำนวนตั๋ว (สีน้ำเงิน) -->
                        <div class="summary-card color-blue">
                          <div class="item-content">
                            <span class="label">{{ $t("content.amnallticket") }}</span>
                            <span class="value">{{ formatNumberString(summaryDetail.ticket) }}</span>
                          </div>
                        </div>

                        <!-- รายการที่ 2: จำนวนลูกค้า (สีเขียว) -->
                        <div class="summary-card color-green">
                          <div class="item-content">
                            <span class="label">{{ $t("content.amcustrans") }}</span>
                            <span class="value">{{ formatNumberString(summaryDetail.customer) }}</span>
                          </div>
                        </div>

                        <!-- รายการที่ 3: ลายนิ้วมือผู้มีอำนาจ (สีแดง/ชมพู) -->
                        <div class="summary-card color-red">
                          <div class="item-content">
                            <span class="label">{{ $t("content.amtkrepresent") }}</span>
                            <span class="value">{{ formatNumberString(summaryDetail.shopRepresent) }}</span>
                          </div>
                        </div>
                      </div>
                      <pre></pre><pre></pre><pre></pre>
                    </div>

                    
                    <!-- ───── มุมมองรูปภาพ ───── -->
                    <div v-if="detailViewMode === 'visual' && tranlist.length > 0" class="row mt-3 me-3">
                      <div class="col-lg-6 mb-3">
                        <h6 class="mb-2"><b>ปริมาณและประเภทธุรกรรม แยกตามช่องทาง</b></h6>
                        <div style="position:relative;height:340px;">
                          <Bar :data="detailStackedData" :options="detailStackedOptions" />
                        </div>
                      </div>
                      <div class="col-lg-6 mb-3">
                        <h6 class="mb-2"><b>5 อันดับมูลค่าธุรกรรมสูงสุด (บาท)</b></h6>
                        <div style="position:relative;height:340px;">
                          <Bar :data="detailTop5Data" :options="detailTop5Options" :plugins="[ChartDataLabels]" />
                        </div>
                      </div>
                      <div class="col-12 mb-2 mt-2">
                        <h6 class="mb-2"><b>ภาพรวมสัดส่วนการยืนยันตัวตนและความปลอดภัย (Security Check)</b></h6>
                        <div v-if="detailSecurity.total > 0" class="detail-security-bar">
                          <div
                            v-for="(seg, sIdx) in detailSecurity.segments" v-show="seg.count > 0" :key="sIdx"
                            class="detail-security-seg"
                            :style="{ width: seg.pct + '%', backgroundColor: seg.color }"
                            :title="`${seg.label}: ${formatNumberString(seg.count)} (${seg.pct.toFixed(1)}%)`">
                            <span v-if="seg.pct >= 12" class="seg-label">{{ seg.label }}</span>
                            <span class="seg-pct">{{ seg.pct.toFixed(0) }}%</span>
                          </div>
                        </div>
                        <div class="detail-security-legend">
                          <span v-for="(seg, sIdx2) in detailSecurity.segments" :key="sIdx2">
                            <i :style="{ backgroundColor: seg.color }"></i>
                            {{ seg.label }} <b>{{ formatNumberString(seg.count) }}</b>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div v-if="detailViewMode === 'visual' && tranlist.length === 0" class="row mt-3 me-3">
                      <p style="text-align: center">No Record Found</p>
                    </div>

                    <!-- ───── มุมมองตาราง (แบบเดิม) ───── -->
                    <div v-show="detailViewMode === 'table'" class="row mt-3 me-3">
                      <div class="table-responsive">
                        <table class="table table-flush">
                          <thead class="thead-light">
                            <tr>
                              <th class="align-top text-center">{{ $t("content.amnchannel") }}</th>
                              <th class="align-top text-center">{{ $t("content.trans") }}</th>
                              <th class="align-top text-center">{{ $t("content.amnticall") }}</th>
                              <th class="align-top text-center">{{ $t("content.actpawn3") }}/{{ $t("content.actpawn4") }}</th>
                              <th class="align-top text-center">{{ $t("content.amnreceiveprofit") }}</th>
                              <th class="align-top text-center">{{ $t("content.amntotalval") }}</th>
                              <th class="align-top text-center">{{ $t("content.massetgroup") }}</th>
                              <th colspan ="4" class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                 {{ $t("content.idcard") }}
                                </span>
                              </th>
                              <th class="align-top text-center">{{ $t("content.autfingerprint") }}</th>
                            </tr>
                            <tr>
                              <th colspan="7"></th>
                              <th
                                colspan="2" class="align-top text-center"
                                style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.usecard") }}
                                </span>
                              </th>
                              <th
                                colspan="2" class="align-top text-center"
                                style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.donusecard") }}
                                </span>
                              </th>
                              <th class="align-top text-center"></th>
                            </tr> 
                            <tr>
                              <th colspan="7"></th>
                              <th
                                class="align-top text-center"
                                style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.donuseotp") }}
                                </span>
                              </th>
                              <th
                                class="align-top text-center"
                                style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.useotp") }}
                                </span>
                              </th>
                              <th
                                class="align-top text-center"
                                style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.donuseotp") }}
                                </span>
                              </th>
                              <th
                                class="align-top text-center"
                                style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.useotp") }}
                                </span>
                              </th>
                              <th class="align-top text-center"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                               v-for="(row, index) in tranlist" :key="index"
                               :class="{ 'group-start': row.isFirstInGroup, 'group-end': row.isLastInGroup }">
                              <td class="text-sm font-weight-bold text-center">
                                <template v-if="row.isFirstInGroup">
                                  <span v-if="row.channel === 'normal'" style="color:blue; font-weight:bold;">{{ $t("content.cintrate1") }}</span>
                                  <span v-else-if="row.channel === 'migration'" style="color:blue; font-weight:bold;">{{ $t("content.transmig") }}</span>
                                  <span v-else-if="row.channel === 'outage'" style="color:blue; font-weight:bold;">{{ $t("content.outage2") }}</span>
                                  <span v-else-if="row.channel === 'outage-migration'" style="color:blue; font-weight:bold;">{{ $t("content.outage2") }} ({{ $t("content.transmig") }})</span>
                                  <span v-else-if="row.channel === 'line'" style="color:blue; font-weight:bold;">Line OA</span>
                                  <span v-else-if="row.channel === 'q04'" style="color:blue; font-weight:bold;">{{ $t("content.backlogq04") }}</span>
                                  <!-- ถ้าเป็นค่าว่าง ให้แสดงขีดหรือข้อความ default -->
                                  <span v-else></span> 
                                </template>
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                {{ checkTransaction2(row.type) }}
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                {{ formatNumberString(row.total) }}
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                {{ formatNumberDecimalString(row.diffValue) }}
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                {{ formatNumberDecimalString(row.roundInterest) }}
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                {{ formatNumberDecimalString(row.pawnValue) }}
                              </td>
                               <td class="text-sm font-weight-normal text-center">
                                <material-button
                                  color="info" variant="outline" class="rounded-circle"
                                  :title="t('buttons.seed')" :disabled="row.channel === 'q04'"
                                  @click="getCatDetailInfo(row)">
                                  <i class="material-icons material-symbols-outlined">manage_search</i>
                                </material-button>
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                <span
                                v-if="Number(row.idNoOtp) > 0 && row.channel !== 'q04'" style="text-decoration:underline;cursor: pointer;color:blue;"
                                  @click="goToHistory_detail(13,row.channel,row.type)">
                                    {{ formatNumberString(row.idNoOtp) }} 
                                </span>
                                <span v-else-if ="Number(row.idNoOtp) > 0 && row.channel === 'q04'">
                                    {{ formatNumberString(row.idNoOtp) }} 
                                </span>
                                <span v-else>
                                       -
                                </span>
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                <span
                                  v-if="Number(row.idOtp) > 0 && row.channel !== 'q04'" style="text-decoration:underline;cursor: pointer;color:blue;"
                                  @click="goToHistory_detail(14,row.channel,row.type)">
                                    {{ formatNumberString(row.idOtp) }} 
                                </span>
                                <span v-else-if ="Number(row.idOtp) > 0 && row.channel === 'q04'">
                                    {{ formatNumberString(row.idOtp) }} 
                                </span>
                                <span v-else>
                                       -
                                </span>
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                <span
                                  v-if="Number(row.noIdNoOtp) > 0 && row.channel !== 'q04'" style="text-decoration:underline;cursor: pointer;color:blue;"
                                  @click="goToHistory_detail(15,row.channel,row.type)">
                                    {{ formatNumberString(row.noIdNoOtp) }} 
                                </span>
                                <span v-else-if ="Number(row.noIdNoOtp) > 0 && row.channel === 'q04'">
                                    {{ formatNumberString(row.noIdNoOtp) }} 
                                </span>
                                <span v-else>
                                       -
                                </span>
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                <span
                                  v-if="Number(row.noIdOtp) > 0 && row.channel !== 'q04'" style="text-decoration:underline;cursor: pointer;color:blue;"
                                  @click="goToHistory_detail(16,row.channel,row.type)">
                                    {{ formatNumberString(row.noIdOtp) }} 
                                </span>
                                <span v-else-if ="Number(row.noIdOtp) > 0 && row.channel === 'q04'">
                                    {{ formatNumberString(row.noIdOtp) }} 
                                </span>
                                <span v-else>
                                       -
                                </span>
                              </td>
                              <td class="text-sm font-weight-normal text-center">
                                <span
                                  v-if="Number(row.shopRepresent) > 0 && row.channel !== 'q04'" style="text-decoration:underline;cursor: pointer;color:blue;"
                                  @click="goToHistory_detail(17,row.channel,row.type)">
                                    {{ formatNumberString(row.shopRepresent) }} 
                                </span>
                                <span v-else-if ="Number(row.shopRepresent) > 0 && row.channel === 'q04'">
                                    {{ formatNumberString(row.shopRepresent) }} 
                                </span>
                                <span v-else>
                                       -
                                </span>
                              </td>
                            </tr>
                            <tr v-if="tranlist.length === 0">
                              <td colspan="15" class="text-sm font-weight-normal">
                                <p style="text-align: center">No Record Found</p>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                  <pre></pre><pre></pre><pre></pre>
                </div>

                <div class="col-12 mb-3">
                  <div class="card mt-3">
                    <div class="card-header mb-0">
                      <h5>{{ $t("content.graphcustran") }}</h5>
                    </div>
                    <div class="card-body pt-0">
                      <div class="row">
                        <div class="col-12 mb-4">
                          <div class="p-3 mt-2 card-body">
                            <div v-if="graphDataDetail !== null" class = "row">                            
                                <TransactionChart :transactions="graphDataDetail" />
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
                  </div>
                </div>

              </div>
             </div>
          </div>

          <div id="tab4" class="tab-pane fade" role="tabpanel" aria-labelledby="tab4-tab">
            <div class="row">
              <div class="col-12 mb-3">
                <div class="card h-100 mt-3">
                    <div class="col-12 mb-4">
                        <div class="p-3 pb-0 card-header">
                          <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <h5 class="mb-0">
                              <b>{{ $t("content.amndue") }}</b>
                            </h5>
                          </div>
                        </div>
                      <div class="p-3 mt-2">
                        <div class="row">
                          <div v-for="(a, pt3) in legendDue" :key="pt3" class="col-12 text-start mb-3">
                            <div class="d-flex justify-content-between align-items-center">
                              <p class="mb-1">{{ a.hd }}</p>
                              <div class="d-flex align-items-center">
                                <h4 class="mb-0">
                                  <b><span :class="a.tx">{{ fmNumber(a.vs) }}</span></b>
                                </h4>
                                &nbsp;
                                <p class="text-sm mb-0">/{{ fmNumber(a.vm) }}</p>
                              </div>
                            </div>

                            <div class="progress dashboard">
                              <div
                                v-if="a.vs !== 0 && a.vm !== 0" class="progress-bar" :class="a.bg" role="progressbar"
                                :style="'width: ' + calPercent(a.vs, a.vm) + '%;'" :aria-valuenow="calPercent(a.vs, a.vm)"
                                aria-valuemin="0" aria-valuemax="100">
                                {{ Number(calPercent(a.vs, a.vm)).toLocaleString() }}%
                              </div>
                              <div
                                v-else class="progress-bar" :class="a.bg" role="progressbar"
                                :style="'width: ' + 2 + '%;'" :aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                                0%
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row mt-4" style="overflow-x: auto; padding-right: 1em">
                          <h5 class="">{{ $t("content.amnticketduelist") }}</h5>
                          <div class="table-responsive">
                            <table class="table">
                              <thead class="thead-light">
                                <tr>
                                  <th>#</th>
                                  <th v-if="dueGroup">{{ $t("content.shopgrp_branch") }}</th>
                                  <th>{{ $t("content.amnduedate") }}</th>
                                  <th>{{ $t("content.amndeferdate") }}</th>
                                  <th>{{ $t("content.names") }}</th>
                                  <th>{{ $t("content.ticketno") }}</th>
                                  <th>{{ $t("content.allweight") }}</th>
                                  <th>{{ $t("content.allqty") }}</th>
                                  <th>{{ $t("content.allprice") }}</th>
                                  <th>{{ $t("content.cintrate") }}</th>
                                  <th>{{ $t("content.act") }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(row, index) in duelist" :key="index">
                                  <td class="text-sm font-weight-normal">{{
                                    formatNumberString((currentPage - 1) * perPage + index
                                      +
                                      1) }}</td>
                                  <td v-if="dueGroup" class="text-sm font-weight-normal">
                                    {{ dueRowShopName(row) }}
                                  </td>
                                  <td class="text-sm font-weight-normal">
                                    {{ format_date(row.dueDate) }}
                                  </td>
                                  <td class="text-sm font-weight-normal">
                                    {{ format_date(row.postponeDate) }}
                                  </td>
                                  <td class="text-sm font-weight-normal">
                                    <!-- <span @click="searchCustomer(row)"
                                      style="color:blue;text-decoration:underline;cursor: pointer">
                                      {{ row.cusName }}
                                    </span> -->
                                    {{ row.cusName }}
                                    <material-button
v-show="false" id="exampleModalShow"
                                      data-bs-toggle="modal" data-bs-target="#exampleModal">
                                    </material-button>
                                  </td>
                                  <td class="text-sm font-weight-normal">
                                    {{ row.refNumber }}
                                  </td>
                                  <td class="text-sm font-weight-normal">
                                    {{ formatNumberDecimalString(row.weight) }}
                                  </td>
                                  <td class="text-sm font-weight-normal">
                                    {{ formatNumberString(row.quantity) }}
                                  </td>
                                  <td class="text-sm font-weight-normal">
                                    {{ formatNumberDecimalString(row.newPawnValue) }}
                                  </td>
                                  <td class="text-sm font-weight-normal">
                                    {{ formatNumberDecimalString(row.interestPerMonth) }}
                                  </td>
                                  <td class="text-sm font-weight-normal">
                                    <material-button
                                      color="info" variant="outline" class="rounded-circle"
                                      :title="t('buttons.seed')" @click="openDetail(row)">
                                      <i class="material-icons material-symbols-outlined">visibility</i>
                                    </material-button>
                                    <material-button
                                      v-show="false" id="detailModal" color="info" variant="outline"
                                      class="rounded-circle" data-bs-toggle="modal" data-bs-target="#lookupModal2">
                                    </material-button>
                                  </td>
                                </tr>
                                <tr v-if="duelist.length === 0">
                                  <td colspan="11" class="text-sm font-weight-normal">
                                    <p style="text-align: center">No Record Found</p>
                                  </td>
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td colspan="14" style="text-align: right">Total Rows : {{
                                    totalRows_s }}</td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                        <pre></pre>
                        <div style="display: flex; justify-content: flex-end">
                          <ul v-show="duelist.length > 0" class="pagination justify-content-end">
                            <div class="project-container">
                              <div class="example-one">
                                <vue-awesome-paginate
                                  v-model="currentPage" :total-items="totalRows"
                                  :items-per-page="perPage" @click="onClickHandler" />
                              </div>
                            </div>
                          </ul>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="tab5" class="tab-pane fade" role="tabpanel" aria-labelledby="tab5-tab">
            <div v-if="shop_seleted !== '0'" class="row">
              <div class="col-12">
                <div class="card mt-3 workflow-dashboard-card">
                  <div class="card-header pb-0">
                    <div class="d-flex justify-content-between align-items-center flex-wrap gap-3">
                      <div>
                        <h5 class="mb-0"><b>งานค้างทั้งหมดในระบบ</b></h5>
                        <p class="text-sm text-secondary mb-0">
                          {{ $t("content.up_d") }} : {{ res_time || '-' }}
                        </p>
                      </div>
                      <material-button color="primary" class="m-0 text-nowrap px-3" @click="refreshWorkflowDashboard">
                        <i class="material-icons material-symbols-outlined">refresh</i>
                        อัปเดต
                      </material-button>
                    </div>
                  </div>

                  <div class="card-body">
                    <div class="row g-3 mb-3">
                      <div class="col-xl-4 col-md-6">
                        <div class="workflow-total-card h-100">
                          <span class="workflow-kicker">งานค้างทั้งหมดในระบบ</span>
                          <div class="workflow-total">
                            {{ formatNumberString(workflowAllItems.length) }}
                            <span>งาน</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-2 col-md-6">
                        <div class="workflow-stat-card h-100">
                          <span>งานที่มีเจ้าของแล้ว</span>
                          <strong>{{ formatNumberString(workflowOwnedCount) }}</strong>
                        </div>
                      </div>
                      <div class="col-xl-3 col-md-6">
                        <div class="workflow-stat-card h-100">
                          <span>รอนานเกิน 30 นาที</span>
                          <strong>{{ formatNumberString(workflowWaitingCount) }}</strong>
                        </div>
                      </div>
                      <div class="col-xl-3 col-md-6">
                        <div class="workflow-stat-card workflow-stat-warning h-100">
                          <span>งานค้างที่เกาเกิน 1 ชั่วโมง</span>
                          <strong>{{ formatNumberString(workflowVaultLongCount) }}</strong>
                        </div>
                      </div>
                    </div>

                    <!-- Payment Cashflow Summary -->
                    <div class="workflow-payment-summary mb-3">
                      <h6 class="mb-2"><b>สรุปการชำระที่ค้าง</b></h6>
                      <div class="row g-2">
                        <div class="col-md-6">
                          <div class="workflow-cashflow-card workflow-cashflow-payout">
                            <div class="workflow-cashflow-header">
                              <i class="material-icons material-symbols-outlined">arrow_circle_up</i>
                              <span>จ่ายออก (ร้านจ่ายลูกค้า)</span>
                              <span class="workflow-cashflow-badge">{{ formatNumberString(workflowPayoutSummary.count) }} งาน</span>
                            </div>
                            <div class="workflow-cashflow-total wf-payout">
                              {{ workflowPayoutSummary.count > 0 ? formatNumberDecimalString(workflowPayoutSummary.total) : '-' }}
                              <span v-if="workflowPayoutSummary.count > 0">บาท</span>
                            </div>
                            <div class="workflow-cashflow-methods">
                              <div v-if="workflowPaymentMethodLoading" class="workflow-cashflow-note">กำลังโหลดรายละเอียด...</div>
                              <template v-else-if="Object.keys(workflowPaymentMethodSummary.payout).length > 0">
                                <div
                                  v-for="(amt, type) in workflowPaymentMethodSummary.payout" :key="type"
                                  class="workflow-cashflow-method-row">
                                  <span class="workflow-cashflow-method-label">{{ workflowPaymentTypeText(type) }}</span>
                                  <strong class="workflow-cashflow-method-amt wf-payout">{{ formatNumberDecimalString(amt) }}</strong>
                                </div>
                              </template>
                              <div v-else class="workflow-cashflow-note">ไม่มีรายการจ่ายออก</div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="workflow-cashflow-card workflow-cashflow-receive">
                            <div class="workflow-cashflow-header">
                              <i class="material-icons material-symbols-outlined">arrow_circle_down</i>
                              <span>รับเข้า (ลูกค้าจ่ายร้าน)</span>
                              <span class="workflow-cashflow-badge">{{ formatNumberString(workflowReceiveSummary.count) }} งาน</span>
                            </div>
                            <div class="workflow-cashflow-total wf-receive">
                              {{ workflowReceiveSummary.count > 0 ? formatNumberDecimalString(workflowReceiveSummary.total) : '-' }}
                              <span v-if="workflowReceiveSummary.count > 0">บาท</span>
                            </div>
                            <div class="workflow-cashflow-methods">
                              <div v-if="workflowPaymentMethodLoading" class="workflow-cashflow-note">กำลังโหลดรายละเอียด...</div>
                              <template v-else-if="Object.keys(workflowPaymentMethodSummary.receive).length > 0">
                                <div
v-for="(amt, type) in workflowPaymentMethodSummary.receive" :key="type"
                                  class="workflow-cashflow-method-row">
                                  <span class="workflow-cashflow-method-label">{{ workflowPaymentTypeText(type) }}</span>
                                  <strong class="workflow-cashflow-method-amt wf-receive">{{ formatNumberDecimalString(amt) }}</strong>
                                </div>
                              </template>
                              <div v-else class="workflow-cashflow-note">ไม่มีรายการรับเข้า</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="workflow-flow-map mb-3">
                      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                        <h6 class="mb-0"><b>งานในระบบ</b></h6>
                      </div>
                      <div class="workflow-flow-grid">
                        <div
v-for="(queue, index) in workflowQueues" :key="queue.code"
                          class="workflow-flow-step" :style="{ '--workflow-accent': queue.color, animationDelay: `${index * 0.05}s` }">
                          <span class="workflow-queue-code">{{ queue.code }}</span>
                          <div class="workflow-queue-name">{{ queue.label }}</div>
                          <div class="workflow-queue-total">
                            {{ formatNumberString(workflowQueueCount(queue.code)) }}
                            <span>งาน</span>
                          </div>
                          <div
v-if="workflowQueueCashNet(queue.code) !== 0" class="workflow-queue-cash"
                            :class="workflowQueueCashNet(queue.code) > 0 ? 'wf-net-receive' : 'wf-net-payout'">
                            <span>{{ workflowQueueCashNet(queue.code) > 0 ? 'รับ' : 'จ่าย' }}</span>
                            <strong>{{ formatNumberDecimalString(Math.abs(workflowQueueCashNet(queue.code))) }}</strong>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex gap-2 mb-3">
                      <input
v-model="workflowSearchText" type="text"
                        class="workflow-search-input"
                        placeholder="ค้นหาเลขงาน, ชื่อลูกค้า, เลขตั๋ว"
                        autocomplete="off" />
                      <div class="workflow-filter-group">
                        <button
type="button" :class="{ active: workflowStatusFilter === 'ALL' }"
                          @click="workflowStatusFilter = 'ALL'">
                          ทั้งหมด
                        </button>
                        <button
type="button" :class="{ active: workflowStatusFilter === 'WAITING' }"
                          @click="workflowStatusFilter = 'WAITING'">
                          รอนาน
                        </button>
                      </div>
                    </div>

                    <div class="row g-3">
                      <div class="col-12">
                        <div class="workflow-board">
                          <div
v-for="queue in workflowQueues" :key="queue.code" class="workflow-lane"
                            :style="{ '--workflow-accent': queue.color }">
                            <div class="workflow-lane-header">
                              <span>{{ queue.label }}</span>
                              <b>{{ formatNumberString(workflowFilteredByQueue(queue.code).length) }}</b>
                            </div>

                            <div class="workflow-lane-body">
                              <div v-if="workflowFilteredByQueue(queue.code).length > 0">
                                <div
v-for="(item, index) in workflowFilteredByQueue(queue.code)" :key="item.key"
                                  role="button" tabindex="0" class="workflow-item-card"
                                  :class="{ selected: selectedWorkflowItem && selectedWorkflowItem.key === item.key }"
                                  :style="{ animationDelay: `${Math.min(index * 0.03, 0.18)}s`, background: workflowCardBg(item) }"
                                  @click="selectWorkflowItem(item)"
                                  @keydown.enter.self="selectWorkflowItem(item)"
                                  @keydown.space.self.prevent="selectWorkflowItem(item)">
                                  <div class="d-flex justify-content-between align-items-center gap-2">
                                    <span class="workflow-job-id">Job : {{ item.jobId || '-' }}</span>
                                    <span class="workflow-age" :class="{ waiting: isWorkflowWaiting(item) || isWorkflowVaultLong(item) }">
                                      {{ workflowAgeText(item.ageMinutes) }}
                                    </span>
                                  </div>
                                  <div class="workflow-customer">{{ item.customerName }}</div>
                                  <div class="workflow-card-meta">
                                    <span class="workflow-desc">
                                      {{ item.transactionText }} · {{ item.newRefNumber || '-' }}
                                    </span>
                                    <span class="workflow-cash-value" :class="workflowCashClass(item.cashValue)">
                                      {{ workflowCashText(item.cashValue) }}
                                    </span>
                                  </div>
                                  <div class="workflow-card-footer">
                                    <span class="workflow-owner">{{ item.ownerName || '-' }}</span>
                                    <div class="workflow-card-actions" aria-label="เครื่องมือทรัพย์">
                                      <button
type="button" class="workflow-card-action workflow-card-action-coll"
                                        title="รายละเอียดทรัพย์" aria-label="รายละเอียดทรัพย์"
                                        :disabled="item.isPayment || !item.workCaseUid"
                                        @click.stop="openWorkflowCardAsset(item, 'coll')">
                                        <i class="material-icons material-symbols-outlined">manage_search</i>
                                      </button>
                                      <button
type="button" class="workflow-card-action workflow-card-action-img"
                                        title="รูปทรัพย์" aria-label="รูปทรัพย์"
                                        :disabled="item.isPayment || !item.workCaseUid"
                                        @click.stop="openWorkflowCardAsset(item, 'img')">
                                        <i class="material-icons material-symbols-outlined">photo_library</i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div v-else class="workflow-empty-lane">
                                ไม่มีงานในคิวนี้
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Workflow Detail Modal -->
                    <div id="workflowDetailModal" class="modal fade" tabindex="-1" aria-labelledby="workflowDetailModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered">
                        <div v-if="selectedWorkflowItem" class="modal-content">
                          <div class="modal-header" :style="{ background: selectedWorkflowItem.color + '18', borderBottom: '3px solid ' + selectedWorkflowItem.color }">
                            <div>
                              <span class="workflow-detail-chip">
                                {{ selectedWorkflowItem.queueCode }} · {{ selectedWorkflowItem.queueLabel }}
                              </span>
                              <h6 class="mt-2 mb-0"><b>{{ selectedWorkflowItem.jobId || '-' }}</b></h6>
                            </div>
                            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                              <i class="material-icons material-symbols-outlined">close</i>
                            </button>
                          </div>
                          <div class="modal-body">
                            <div class="workflow-detail-summary">
                              <div>
                                <span class="workflow-detail-label">ลูกค้า</span>
                                <strong>{{ selectedWorkflowItem.customerName }}</strong>
                                <small>{{ selectedWorkflowItem.transactionText }} · Job : {{ selectedWorkflowItem.jobId || '-' }}</small>
                              </div>
                              <span class="workflow-detail-queue-badge" :style="{ background: selectedWorkflowItem.color }">
                                {{ selectedWorkflowItem.queueLabel }}
                              </span>
                            </div>

                            <div class="workflow-detail-section">
                              <div class="workflow-detail-section-title">
                                <i class="material-icons material-symbols-outlined">assignment</i>
                                <span>ข้อมูลงาน</span>
                              </div>
                              <div class="workflow-detail-grid">
                                <div v-if="!selectedWorkflowItem.isPayment" class="workflow-detail-row">
                                  <span>เลขที่ตั๋วเก่า</span>
                                  <b>{{ selectedWorkflowItem.oldRefNumber || '-' }}</b>
                                </div>
                                <div v-if="!selectedWorkflowItem.isPayment" class="workflow-detail-row">
                                  <span>เลขที่ตั๋วใหม่</span>
                                  <b>{{ selectedWorkflowItem.newRefNumber || '-' }}</b>
                                </div>
                                <div v-if="selectedWorkflowItem.isPayment" class="workflow-detail-row workflow-detail-row--full">
                                  <span>ตั๋วที่เกี่ยวข้อง</span>
                                  <div>
                                    <span v-if="workflowPaymentTypesLoading" class="workflow-detail-muted">กำลังโหลด...</span>
                                    <div v-else-if="workflowDisplayWorkCases.length > 0" class="workflow-workcases">
                                      <span
                                        v-for="wc in workflowDisplayWorkCases"
                                        :key="wc.tkRefNumber || wc.uid"
                                        class="workflow-workcase-chip"
                                        :style="{
                                          background: workflowWcColor(wc.transactionType) + '18',
                                          borderColor: workflowWcColor(wc.transactionType) + '55',
                                          color: workflowWcColor(wc.transactionType),
                                        }">
                                        {{ wc.tkRefNumber || '-' }}
                                        <small :style="{ color: workflowWcColor(wc.transactionType) + 'bb' }">
                                          {{ checkTransaction(wc.transactionType) }}
                                        </small>
                                      </span>
                                    </div>
                                    <span v-else class="workflow-detail-muted">-</span>
                                  </div>
                                </div>
                                <div class="workflow-detail-row">
                                  <span>ผู้ถือครองงาน</span>
                                  <b>{{ selectedWorkflowItem.ownerName || '-' }}</b>
                                </div>
                                <div class="workflow-detail-row">
                                  <span>รอมานาน</span>
                                  <b>
                                    {{ workflowAgeText(selectedWorkflowItem.ageMinutes) }}
                                    <small v-if="isWorkflowWaiting(selectedWorkflowItem)" class="text-warning">
                                      รอนานเกิน 30 นาที
                                    </small>
                                    <small v-if="isWorkflowVaultLong(selectedWorkflowItem)" class="text-danger">
                                      เกาเกิน 1 ชั่วโมง
                                    </small>
                                  </b>
                                </div>
                              </div>
                            </div>

                            <div class="workflow-detail-section">
                              <div class="workflow-detail-section-title">
                                <i class="material-icons material-symbols-outlined">payments</i>
                                <span>มูลค่า</span>
                              </div>
                              <div class="workflow-detail-value-grid" :class="{ 'single': selectedWorkflowItem.isPayment }">
                                <div v-if="!selectedWorkflowItem.isPayment" class="workflow-detail-value-card">
                                  <span>ราคาจำนำ</span>
                                  <strong>{{ formatNumberDecimalString(selectedWorkflowItem.pawnValue) }}</strong>
                                  <small>บาท</small>
                                </div>
                                <div class="workflow-detail-value-card">
                                  <span class="workflow-detail-cash-label">
                                    <span class="workflow-cash-receive">รับ</span>
                                    <span>/</span>
                                    <span class="workflow-cash-pay">จ่าย</span>
                                  </span>
                                  <strong :class="workflowCashClass(selectedWorkflowItem.cashValue)">
                                    {{ workflowCashText(selectedWorkflowItem.cashValue) }}
                                  </strong>
                                  <small>บาท</small>
                                </div>
                              </div>
                            </div>

                            <div class="workflow-detail-section">
                              <div class="workflow-detail-section-title">
                                <i class="material-icons material-symbols-outlined">account_balance_wallet</i>
                                <span>ประเภทการชำระ</span>
                              </div>
                              <div class="workflow-payment-detail-list">
                                <span v-if="workflowPaymentTypesLoading">กำลังโหลด...</span>
                                <span v-else-if="workflowPaymentTypes.length > 0" class="workflow-payment-types">
                                  <span v-for="payment in workflowPaymentTypes" :key="payment.type" class="workflow-payment-type-chip">
                                    {{ workflowPaymentTypeText(payment.type) }}
                                    <span class="workflow-payment-type-amount">
                                      <template v-for="(part, partIndex) in workflowPaymentTypeAmountParts(payment)" :key="part.kind">
                                        <span v-if="partIndex > 0" class="workflow-payment-type-separator">/</span>
                                        <span :class="['workflow-payment-type-part', `workflow-payment-type-${part.kind}`]">
                                          {{ part.text }}
                                        </span>
                                      </template>
                                    </span>
                                  </span>
                                </span>
                                <span v-else class="workflow-detail-muted">-</span>
                              </div>
                            </div>
                          </div>
                          <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                              ปิด
                            </button>
                            <div class="d-flex gap-2">
                              <button
                                type="button" class="btn btn-outline-info"
                                :disabled="selectedWorkflowItem.isPayment"
                                @click="getCollecteralFromWorkflowModal(selectedWorkflowItem.workCaseUid, 'coll')">
                                รายละเอียดทรัพย์
                              </button>
                              <button
                                type="button" class="btn btn-outline-success"
                                :disabled="selectedWorkflowItem.isPayment"
                                @click="getCollecteralFromWorkflowModal(selectedWorkflowItem.workCaseUid, 'img')">
                                รูปทรัพย์
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Detail Modal -->
          <TicketDetailModal 
          v-if="workcaseDetail !== null"
          v-model:fcusdt="fcusdt"
          :workcase-detail="workcaseDetail"
          :images="images"
          :listinfo="listinfo"
          :payment-e="paymentE"
          :payment-l="payment_l"
          :promotion-detail="promotionDetail"
          :dep-ref="dep_ref"
          :tk-status="tk_status"
          :int-cal="int_cal"
          :int-period="int_period"
          :transaction-label="checkTransaction(workcaseDetail.transactionType)" 
          :history="'no'" 
          :af-changename=af_changename
          :bf-changename=bf_changename
          :trans-date-prv=transdate_prv
          @copy="copyBtn"
          @open-history="NewTab"/>

          <!--Customer Modal -->
        <div id="exampleModal" class="modal fade" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h1 id="exampleModalLabel" class="modal-title fs-5">
                  {{ $t('content.bcustomer') }} :
                  <span style="color: blue;">
                    {{ cusShop.cusName }}
                  </span>
                </h1>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>
              <div class="modal-body">
                <div class="row mt-2">
                  <div class="col-lg-4">
                    <label class="form-label ms-0">{{ $t('content.cmobile') }}1*</label>
                    <InputMask v-model="cusShop.phoneNo1" mask="(999) 999-9999" fluid disabled />
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label ms-0">{{ $t('content.cmobile') }}2</label>
                    <InputMask v-model="cusShop.phoneNo2" mask="(999) 999-9999" fluid disabled />
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label ms-0">{{ $t('content.cmobile') }}3</label>
                    <InputMask v-model="cusShop.phoneNo3" mask="(999) 999-9999" fluid disabled />
                  </div>
                  <pre></pre>
                  <div class="col-4">
                    <label class="form-label ms-0">{{ $t('content.amntypecustomer') }}</label>
                    <select v-model="cusShop.cusTypeUid" class="form-select" disabled>
                      <option value="0" disabled selected>{{ $t('content.select') }}</option>
                      <option v-for="(item, index) in custypeList" :key="index" :value="item.uid">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-4">
                    <div class="flex-auto">
                      <label class="form-label ms-0">{{ $t('content.amncredit') }}</label>
                      <InputNumber v-model="cusShop.creditAmount" autocomplete="off" disabled fluid />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="flex-auto">
                       <label class="form-label ms-0" style="color:blue">Line ID</label>
                      <material-input v-model="displayName" type="text" disabled/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

        <!-- Gallery Modal (global — outside all tab-panes so it renders from any tab) -->
        <div id="galleryDetailModal" class="modal fade" tabindex="-1" aria-labelledby="galleryDetailModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" style="max-width: 520px">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.jobId") }} : {{jobId}} </h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>
              <div class="modal-body">
                <div id="lookupImages" class="carousel slide" data-bs-touch="false" data-bs-interval="false">
                  <div class="carousel-indicators">
                    <div id="demo2" class="carousel-indicators">
                    </div>
                  </div>
                  <div class="carousel-inner">
                    <ul className="list-unstyled">
                      <li v-for="(item, index) in images.length" :key="index">
                        <span v-if="index === 0">
                          <div class="carousel-item active">
                            <vue-image-zoomer
                              :regular="images[index].src" img-class="img-fluid" class="d-block w-100"
                              :zoom-amount="3" :click-zoom="true" close-pos="top-right" message-pos="top" />
                          </div>
                        </span>
                        <span v-else>
                          <div class="carousel-item">
                            <vue-image-zoomer
                              :regular="images[index].src" img-class="img-fluid" class="d-block w-100"
                              :zoom-amount="3" :click-zoom="true" close-pos="top-right" message-pos="top" />
                          </div>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <button class="carousel-control-prev" type="button" data-bs-target="#lookupImages" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button class="carousel-control-next" type="button" data-bs-target="#lookupImages" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>



      

    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import Modal from 'bootstrap/js/dist/modal';
import DashboardOverview from '@/components/dashboard/DashboardOverview.vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { ref, reactive, computed, inject, onMounted, onBeforeUnmount, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import ProgressSpinner from 'primevue/progressspinner';
import MaterialButton from "@/components/MaterialButton.vue";
import PieChart from "@/examples/Charts/PieChart.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import MaterialInput from "@/components/MaterialInput.vue"
import TransactionChart from '@/examples/Charts/TransactionChart.vue'
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import { Pie, Doughnut, Bar } from 'vue-chartjs';
import { Chart as ChartJS, ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
ChartJS.register(ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend);
// ให้ทุกกราฟใช้ font เดียวกับหน้า dashboard ($font-family-sans-serif)
ChartJS.defaults.font.family = '"THSarabunNew", "Sukhumvit Set", "Prompt", "Tahoma", "Roboto", sans-serif';
ChartJS.defaults.font.size = 14;
import moment from 'moment'
import TicketDetailModal from '@/components/TicketDetailModal.vue';
// ดึง style ของ vue-awesome-paginate (.example-one) มาเหมือนหน้าประวัติธุรกรรม —
// CSS อยู่ใน ExampleOne.vue แบบไม่ scoped ถ้าไม่ import ไว้ pagination ของ tab
// ตั๋วที่ครบกำหนดจะเป็นปุ่มเปล่าเมื่อเปิด dashboard เป็นหน้าแรก
import ExampleOne from "@/examples/ExampleOne";
import ShopScopeSelect from '@/components/ShopScopeSelect.vue';
import GroupLoadingNotice from '@/components/GroupLoadingNotice.vue';
import { runPerShop, memberForRefNumber } from '@/utils/shopGroup'
import noImg from "@/assets/img/noimg.png"


import { useDashboardStore } from '@/stores/dashboard'
import { useWorkItemStore } from '@/stores/workItem'
import { useWorkCaseStore } from '@/stores/workcase'
import { useDocumentStore } from '@/stores/document'
import { useTransactionStore } from '@/stores/transaction'
import { useInterestStore } from '@/stores/interest'
import { usePaymentGroupStore } from '@/stores/paymentgroup'
import { usePaymentStore } from '@/stores/payment'
import { useDepositStore } from '@/stores/deposit'
import { useCusShopStore } from '@/stores/cusshop'
import { useCusLineStore } from '@/stores/cusline'
import { useShopStore } from '@/stores/shop'



const storedash = useDashboardStore()
const storew = useWorkItemStore()
const storewc = useWorkCaseStore()
const stored = useDocumentStore()
const storetr = useTransactionStore()
const storei = useInterestStore()
const storep = usePaymentGroupStore()
const storepay = usePaymentStore()
const storedepo = useDepositStore()
const storecuss = useCusShopStore()
const storecusline = useCusLineStore()
const storesh = useShopStore()


///// variables
const { t } = useI18n();
const swal = inject("$swal");

const start_date = ref(new Date());
const end_date = ref(new Date());
const sum_pvalue = ref(0);
const sum_mvalue = ref(0);
const sum_painvalue = ref(0);
const sum_inderevalue = ref(0);
const sum_intvalue = ref(0);
const sum_pawncase = ref(0);
const sum_pawnvalue = ref(0);
const sum_redeemcase = ref(0);
const sum_redeemvalue = ref(0);
const num_q01 = ref(0);
const num_q02 = ref(0);
const num_q03 = ref(0);
const num_q04 = ref(0);
const num_pay = ref(0);
const list_q01 = ref([]);
const list_q02 = ref([]);
const list_q03 = ref([]);
const list_q04 = ref([]);
const list_pay = ref([]);
const userq = ref('');
const list_userq = ref([]);
const res_time = ref('');
const workflowSearchText = ref('');
const workflowStatusFilter = ref('ALL');
const selectedWorkflowKey = ref('');
const workflowNow = ref(Date.now());
const workflowPaymentTypes = ref([]);
const workflowPaymentWorkCases = ref([]);
const workflowPaymentTypesLoading = ref(false);
let workflowAgeTimer = null;

const shopList = ref([]);
const shop_seleted = ref();
const shop_info = ref(null)

// ───── กลุ่มสาขา (concept เดียวกับ iBuddy Anywhere) ─────
// null = สาขาที่เลือกไว้ (ค่าเริ่มต้น) — tab ภาพรวมกับตั๋วครบกำหนดเลือกแยกกัน
// ไม่จำค่า: เข้าหน้านี้ใหม่ทุกครั้งกลับเป็นสาขาที่เลือก (ref เริ่มใหม่ตอน mount)
const overviewGroup = ref(null)
const dueGroup = ref(null)
const overviewInfoLoading = ref(false)
const overviewError = ref(false)
const overviewUpdatedAt = ref('')
function applyOverviewRange({ from, to }) {
  start_date.value = from
  end_date.value = to
  searchDashboardInfo()
}
function onOverviewReport(report) {
  if (report === 'defer') goToRpDefer()
  else goToRpProfit()
}
const perShopLoading = ref(false)
const perShopDone = ref(0)
const perShopTotal = ref(0)
const perShopFailed = ref([])
const dueLoading = ref(false)
// กันผลของรอบที่ถูกแทนที่แล้ว (เปลี่ยนกลุ่ม/ค้นหาใหม่ระหว่างรอ) มาทับรอบใหม่
let overviewInfoGen = 0
let perShopGen = 0
let dueGen = 0
// สาขาที่ใช้ดูรายละเอียดตั๋วจาก tab ตั๋วครบกำหนดในโหมดกลุ่ม (null = สาขาที่เลือก)
const detailShop = ref(null)

const selectedShopName = computed(() =>
  shop_seleted.value && shop_seleted.value !== '0' ? (shop_seleted.value.nameTh || shop_seleted.value.code || '') : '')

// สาขาที่จะดึงข้อมูล — กลุ่มใช้ groupUid ของสาขาที่เลือก (บริษัทเดียวกัน)
function scopeShops(group) {
  const key = JSON.parse(localStorage.getItem("shop_seleted") || "null");
  if (!group) return key ? [{ uid: key.uid, groupUid: key.groupUid, name: key.nameTh || key.code }] : []
  return (group.members || [])
    .map((m) => ({
      uid: String(m.shopUid ?? m.uid ?? ""),
      groupUid: key?.groupUid,
      name: m.shopName || m.shopCode,
    }))
    .filter((s) => !!s.uid)
}

function detailShopKey() {
  return detailShop.value || JSON.parse(localStorage.getItem("shop_seleted"));
}

// ลิงก์ drill-down ของ tab ภาพรวมพาไปหน้า/modal ของสาขาเดียว — ปิดไว้ในโหมดกลุ่ม
function blockedInGroupMode() {
  if (!overviewGroup.value) return false
  swal(t("content.shopgrp_singleonly"), "", "info")
  return true
}

function overviewSearchAllowed() {
  return !monthDiff() && start_date.value <= end_date.value && ((shop_seleted.value !== null && shop_seleted.value !== '0') || !!overviewGroup.value)
}

function onOverviewGroupChange(group) {
  overviewGroup.value = group
  perShopFailed.value = []
  if (overviewSearchAllowed()) searchDashboardInfo()
}

function onDueGroupChange(group) {
  dueGroup.value = group
  loadDataDueApi()
}

function dueRowShopName(row) {
  const m = memberForRefNumber(dueGroup.value, row.refNumber)
  return m ? (m.shopName || m.shopCode) : String(row.refNumber || '').split('-')[0]
}

function okList(response) {
  if (!response || response.status !== 200 || response.data.rtnDesc !== "success") {
    throw new Error("load failed")
  }
  return response.data.data.list || []
}

// จำนวนลูกค้า LINE OA — API รับได้ทีละสาขา จึงยิงทีละสาขา (พร้อมกันไม่เกิน 3)
// แล้วรวม พร้อมแสดงความคืบหน้า
async function loadOverviewPerShop() {
  const gen = ++perShopGen
  const shops = scopeShops(overviewGroup.value)
  numOfLineCustomer.value = 0
  perShopLoading.value = true
  perShopDone.value = 0
  perShopTotal.value = shops.length
  perShopFailed.value = []

  const { results, failed } = await runPerShop(shops, async (shop) => {
    const line = await storecusline.cusLineListFetch({
      index: "0", size: "1", cusUid: "", shopUid: shop.uid, groupUid: shop.groupUid,
    })
    okList(line)
    return Number(line.data.data.ext.total) || 0
  }, {
    onProgress: (done) => { if (gen === perShopGen) perShopDone.value = done },
    isStale: () => gen !== perShopGen,
  })
  if (gen !== perShopGen) return

  numOfLineCustomer.value = results.reduce((sum, r) => sum + r.value, 0)
  perShopFailed.value = failed.map((s) => s.name)
  perShopLoading.value = false
}

const workflowQueues = computed(() => [
  { code: 'Q01', label: t('content.workQ01'), color: '#11845b' },
  { code: 'Q02', label: t('content.workQ02'), color: '#2563eb' },
  { code: 'Q03', label: t('content.workQ03'), color: '#7c3fa2' },
  { code: 'Q04', label: t('content.workQ04'), color: '#c96f16' },
]);

const workflowAllItems = computed(() => {
  return allqueuelist.value
    .filter((row) => row.queue !== null && row.queue !== undefined && ['Q01', 'Q02', 'Q03', 'Q04'].includes(row.queue.code))
    .map((row, index) => normalizeWorkflowQueueItem(row, index));
});

const workflowFilteredItems = computed(() => {
  const keyword = workflowSearchText.value.trim().toLowerCase();
  return workflowAllItems.value.filter((item) => {
    const text = [
      item.jobId,
      item.customerName,
      item.oldRefNumber,
      item.newRefNumber,
      item.ownerName,
      item.transactionText,
      item.queueLabel,
    ].join(' ').toLowerCase();
    const statusMatched = workflowStatusFilter.value === 'ALL'
      || (workflowStatusFilter.value === 'WAITING' && isWorkflowWaiting(item));
    return statusMatched && (keyword === '' || text.includes(keyword));
  });
});

const selectedWorkflowItem = computed(() => {
  if (!selectedWorkflowKey.value) return null;
  return workflowFilteredItems.value.find((item) => item.key === selectedWorkflowKey.value) || null;
});

const workflowOwnedCount = computed(() => workflowAllItems.value.filter((item) => item.ownerName !== '-').length);
const workflowWaitingCount = computed(() => workflowAllItems.value.filter((item) => isWorkflowWaiting(item)).length);
const workflowVaultLongCount = computed(() => workflowAllItems.value.filter((item) => isWorkflowVaultLong(item)).length);

// cashValue < 0 = roundTotalPay > 0 = ร้านจ่ายออกให้ลูกค้า (สีแดงในตาราง)
const workflowPayoutSummary = computed(() => {
  const items = workflowAllItems.value.filter((item) => item.isPayment && item.cashValue < 0);
  return {
    total: items.reduce((sum, item) => sum + Math.abs(item.cashValue), 0),
    count: items.length,
  };
});

// cashValue > 0 = roundTotalReceive > 0 = ร้านรับเงินจากลูกค้า (สีเขียวในตาราง)
const workflowReceiveSummary = computed(() => {
  const items = workflowAllItems.value.filter((item) => item.isPayment && item.cashValue > 0);
  return {
    total: items.reduce((sum, item) => sum + item.cashValue, 0),
    count: items.length,
  };
});

const workflowPaymentMethodSummary = ref({ payout: {}, receive: {} });
const workflowPaymentMethodLoading = ref(false);

const dataInfo = ref({
  pawnValue: 0,
  interestPawnValue: 0,
  incPawnValue: 0,
  decPawnValue: 0,
  redeemPawnValue: 0,
  interestPawnValueMigration: 0,
  incPawnValueMigration: 0,
  decPawnValueMigration: 0,
  interestAmount: 0,
  incInterestAmount: 0,
  decInterestAmount: 0,
  redeemInterestAmount: 0,
  numOfPawn: 0,
  numOfInterest: 0,
  numOfInc: 0,
  numOfDec: 0,
  numOfInterestMigration: 0,
  numOfIncMigration: 0,
  numOfDecMigration: 0,
  numOfRedeem: 0,
  numOfRedeemInterest: 0,
  numOfCustomer: 0,
  numOfWorkCase: 0,
  numOfActiveWorkCase: 0,
  numOfPostponeWorkCase: 0,
  numOfVoidTicket: 0,
  numOfEditAfterComplete: 0,
  pawnAmount: 0,
  incAmount: 0,
  incDiff: 0,
  decAmount: 0,
  decDiff: 0,
  redeemAmount: 0,
  payAmount: 0,
  receiveAmount: 0,
  sumInterest: 0,
  interestAmountMigration: 0,
  interestTotalPayMigration: 0,
  interestTotalReceiveMigration: 0,
  incAmountMigration: 0,
  incTotalPayMigration: 0,
  incTotalReceiveMigration: 0,
  decAmountMigration: 0,
  decTotalPayMigration: 0,
  decTotalReceiveMigration: 0,
  totalPayMigration: 0,
  totalReceiveMigration: 0,
  numOfCancelTicket: 0,
  numOfTerminate: 0,
  numOfOtp: 0,
  numOfOtpMigration: 0,
  numOfRepresentWorkCase:0,
  numOfOutageWorkCase: 0,
})

const dataDue = ref({})
const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();


const allqueuelist = ref([])
const coll_l = ref([])
const images = ref([])
const images_l = ref([])
const payment_l = ref([])
const loading = ref(false);
const numOfLineCustomer = ref(0);
const int_period = ref('');
const fcusdt = ref(false);
const dep_ref = ref('');
const promotionDetail = ref(null);
const bf_changename = ref('');
const af_changename = ref('');
const transdate_prv = ref(null);
const jobId = ref('');
const loading_i = ref(false);


// ชุดสีประเภทธุรกรรม [จำนำ, ต่อดอก, เพิ่มต้น, ลดต้น, ไถ่ถอน] — อิงหน้า Portfolio ใน frontend-credit
const colors = reactive(["#3b82f6", "#10b981", "#8b5cf6", "#f59e0b", "#f43f5e"]);
const colors2 = reactive(["#dfffdd", "#fecac7", "#b8e0d2"]);
// กราฟย้ายระบบมีแค่ [ต่อดอก, เพิ่มต้น, ลดต้น]
const colorsMig = reactive(["#10b981", "#8b5cf6", "#f59e0b"]);

const viewGraph = ref(true);
const viewInfo = ref(false);

const reportlist = ref([])
const start_dater = ref(new Date());
const end_dater = ref(new Date());
const totalTicket = ref(0);
const totalInterest = ref(0);
const totalPawnValue = ref(0);

const tranlist = ref([])
const start_datet = ref(new Date());
const end_datet = ref(new Date());

const normalDetail = ref(null);
const migrationDetail = ref(null);
const outageDetail = ref(null);
const outageMigrationDetail = ref(null);
const lineDetail = ref(null);
const summaryDetail = ref(null);
const graphDataDetail = ref(null);
const q04DataDetail = ref(null);

// ───── Tab รายละเอียด : สลับมุมมอง รูปภาพ / ตาราง ─────
const detailViewMode = ref(localStorage.getItem('detailViewMode') || 'visual');

function setDetailViewMode(mode) {
  detailViewMode.value = mode
  localStorage.setItem('detailViewMode', mode)
}

// สีประเภทธุรกรรม — ชุดเดียวกับหน้า Portfolio ใน frontend-credit
const detailTypeMeta = [
  { key: 'PAWN', color: '#3b82f6' },
  { key: 'INTEREST', color: '#10b981' },
  { key: 'INC_PRINCIPLE', color: '#8b5cf6' },
  { key: 'DEC_PRINCIPLE', color: '#f59e0b' },
  { key: 'REDEEM', color: '#f43f5e' },
]

function detailChannelName(channel) {
  if (channel === 'normal') return t('content.cintrate1')
  if (channel === 'migration') return t('content.transmig')
  if (channel === 'outage') return t('content.outage2')
  if (channel === 'outage-migration') return `${t('content.outage2')} (${t('content.transmig')})`
  if (channel === 'line') return 'Line OA'
  if (channel === 'q04') return t('content.backlogq04')
  return channel
}

const detailChannels = computed(() => {
  const orders = []
  tranlist.value.forEach((row) => {
    if (!orders.includes(row.channel)) orders.push(row.channel)
  })
  return orders
})

// กราฟแท่งซ้อน: ปริมาณและประเภทธุรกรรม แยกตามช่องทาง
const detailStackedData = computed(() => ({
  labels: detailChannels.value.map(detailChannelName),
  datasets: detailTypeMeta.map((meta) => ({
    label: checkTransaction2(meta.key),
    backgroundColor: meta.color,
    maxBarThickness: 56,
    data: detailChannels.value.map((channel) => {
      const row = tranlist.value.find((r) => r.channel === channel && r.type === meta.key)
      return row ? Number(row.total) : 0
    }),
  })),
}))

const detailStackedOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      stacked: true,
      grid: { display: false },
      ticks: {
        // ไม่ให้ label เอียง — ชื่อยาวที่มีวรรค (เช่น "ระบบขัดข้อง,ไฟดับ (ย้ายระบบ)") ตัดขึ้นบรรทัดใหม่แทน
        maxRotation: 0,
        minRotation: 0,
        autoSkip: false,
        callback(value) {
          const label = this.getLabelForValue(value)
          return label.includes(' ') ? label.split(' ') : label
        },
      },
    },
    y: { stacked: true, ticks: { precision: 0 } },
  },
  plugins: {
    legend: { position: 'bottom', labels: { usePointStyle: true, boxWidth: 10, padding: 16 } },
    tooltip: {
      callbacks: { label: (c) => ` ${c.dataset.label}: ${formatNumberString(c.parsed.y)}` },
    },
  },
}

// 5 อันดับมูลค่าธุรกรรมสูงสุด
const detailTop5 = computed(() =>
  tranlist.value
    .filter((r) => Number(r.pawnValue) > 0)
    .map((r) => ({
      label: `${checkTransaction2(r.type)} (${detailChannelName(r.channel)})`,
      value: Number(r.pawnValue),
      color: detailTypeMeta.find((m) => m.key === r.type)?.color ?? '#94a3b8',
    }))
    .sort((a, b) => b.value - a.value)
    .slice(0, 5)
)

const detailTop5Data = computed(() => ({
  labels: detailTop5.value.map((d) => d.label),
  datasets: [{
    data: detailTop5.value.map((d) => d.value),
    // ใช้สีตามประเภทธุรกรรม ให้ตรงกับกราฟอื่นทั้งหน้า
    backgroundColor: detailTop5.value.map((d) => d.color),
    maxBarThickness: 30,
  }],
}))

const detailTop5Options = {
  indexAxis: 'y',
  responsive: true,
  maintainAspectRatio: false,
  layout: { padding: { right: 96 } },
  scales: {
    x: { display: false },
    y: { grid: { display: false } },
  },
  plugins: {
    legend: { display: false },
    tooltip: { callbacks: { label: (c) => ` ${formatNumberDecimalString(c.parsed.x)}` } },
    datalabels: {
      anchor: 'end',
      align: 'end',
      color: '#344767',
      font: { weight: 'bold', size: 12 },
      formatter: (v) => formatNumberString(v),
    },
  },
}

// Security Check: สัดส่วนการยืนยันตัวตน (บัตรประชาชน / OTP) รวมทุกช่องทาง
const detailSecurity = computed(() => {
  const sumField = (field) => tranlist.value.reduce((acc, r) => acc + Number(r[field] || 0), 0)
  const segments = [
    { label: `${t('content.usecard')} + ${t('content.useotp')}`, count: sumField('idOtp'), color: '#15803d' },
    { label: `${t('content.usecard')} + ${t('content.donuseotp')}`, count: sumField('idNoOtp'), color: '#eab308' },
    { label: `${t('content.donusecard')} + ${t('content.useotp')}`, count: sumField('noIdOtp'), color: '#f97316' },
    { label: `${t('content.donusecard')} + ${t('content.donuseotp')}`, count: sumField('noIdNoOtp'), color: '#dc2626' },
  ]
  const total = segments.reduce((acc, s) => acc + s.count, 0)
  return {
    total,
    segments: segments.map((s) => ({ ...s, pct: total > 0 ? (s.count * 100) / total : 0 })),
  }
})

const listinfo = ref([]);
const customerlist = ref([])
const info_cat = ref('');
const workcaseDetail = ref(null);
const chain_uid = ref('');
const tk_status = ref('');
const int_cal = ref(0);
const paymentE = ref('');
const time = ref(false);

const custypeList = ref([])
const cusShop = ref({
  uid: '',
  cusUid: "",
  shopUid: "",
  cusTypeUid: "0",
  interestUid: "no",
  openAccountDate: null,
  lastActiveDate: null,
  phoneNo1: "",
  phoneNo2: "",
  phoneNo3: "",
  signature1Uid: "0",
  signature2Uid: "0",
  fingerPrint1Uid: "0",
  fingerPrint2Uid: "0",
  fgTemplate1Uid: "0",
  fgTemplate2Uid: "0",
  email: "",
  warningMsg: "",
  notifyWarning: false,
  creditAmount: 0,
  version: '0',
  cusName: "",
})
const displayName = ref('');

const duelist = ref([])
const legendDue = ref([
  {
    hd: computed(() => t("content.amnticketdueactived")),
    vs: Number(0),
    vm: Number(0),
    tx: "text-primary",
    bg: "bg-primary",
  },
  {
    hd: computed(() => t("content.amnticketdued")),
    vs: Number(0),
    vm: Number(0),
    tx: "text-warning",
    bg: "bg-warning",
  },
  // {
  //   hd: computed(() => t("content.amnticketoveractived")),
  //   vs: Number(0),
  //   vm: Number(0),
  //   tx: "text-danger",
  //   bg: "bg-danger",
  // },
  {
    hd: computed(() => t("content.amnticketoverd")),
    vs: Number(0),
    vm: Number(0),
    tx: "text-secondary",
    bg: "bg-secondary",
  },
]);

const legendTimes = ref([{
  bg: "bg-pledge",
  hd: computed(() => t("content.actpawn1")),
  dt: Number(0),
},
{
  bg: "bg-interest",
  hd: computed(() => t("content.actpawn2")),
  dt: Number(0),
},
{
  bg: "bg-add-cap",
  hd: computed(() => t("content.actpawn3")),
  dt: Number(0),
},
{
  bg: "bg-reduce-cap",
  hd: computed(() => t("content.actpawn4")),
  dt: Number(0),
},
{
  bg: "bg-redeem",
  hd: computed(() => t("content.actpawn5")),
  dt: Number(0),
},]);

const legendBaht = ref([
  {
    bg: "bg-pledge",
    hd: computed(() => t("content.actpawn1")),
    dt: Number(0)
  },
  {
    bg: "bg-interest",
    hd: computed(() => t("content.actpawn2")),
    dt: Number(0),
  },
  {
    bg: "bg-add-cap",
    hd: computed(() => t("content.actpawn3")),
    dt: Number(0),
  },
  {
    bg: "bg-reduce-cap",
    hd: computed(() => t("content.actpawn4")),
    dt: Number(0),
  },
  {
    bg: "bg-redeem",
    hd: computed(() => t("content.actpawn5")),
    dt: Number(0),
  },
]);

const legendSum = ref([
  {
    bg: "bg-payment",
    hd: computed(() => t("content.amnoutcome")),
    dt: Number(0)
  },
  {
    bg: "bg-receive",
    hd: computed(() => t("content.amnincome")),
    dt: Number(0),
  },
  {
    bg: "bg-interest",
    hd: computed(() => t("content.amninterest")),
    dt: Number(0),
  },
]);

const legendMig = ref([{
  bg: "bg-interest",
  hd: computed(() => t("content.actpawn2")),
  dt: Number(0),
  dt2: Number(0),
},
{
  bg: "bg-add-cap",
  hd: computed(() => t("content.actpawn3")),
  dt: Number(0),
  dt2: Number(0),
},
{
  bg: "bg-reduce-cap",
  hd: computed(() => t("content.actpawn4")),
  dt: Number(0),
  dt2: Number(0),
},]);

const stats = ref([
  {
    label: 'ยอดตั๋วจํานํา (เข้า)',
    value: 0.00,
    subPrefix: 'จำนวน:',
    subText: '',
    subUnit: 'เบอร์',
    icon: 'volunteer_activism',
    type: 'pawn-in'
  },
  {
    label: 'ยอดตั๋วไถ่ถอน (ออก)',
    value: 0.00,
    subPrefix: 'จำนวน:',
    subText: '',
    subUnit: 'เบอร์',
    icon: 'payments',
    type: 'pawn-out'
  },
  {
    label: 'รายได้ดอกเบี้ยรวม',
    value: 0.00,
    subPrefix: '',
    subText: '',
    subUnit: '',
    icon: 'fas fa-coins',
    type: 'interest'
  },
  {
    label: 'เงินสุทธิวันนี้',
    value: 0.00,
    subPrefix: 'สต๊อคสุทธิ:',
    subText: '',
    subUnit: 'รายการ',
    isRed: true,
    icon: 'fas fa-chart-line',
    type: 'net-cash'
  }
])

// ข้อมูลสำหรับ กราฟยอดตั๋วจํานำ
const pawnData = ref({
  labels: ['จํานำ', 'ต่อดอก', 'เพิ่มต้น', 'ลดต้น'],
  datasets: [{
    data: [0, 0, 0, 0],
    backgroundColor: ['#3b82f6', '#10b981', '#8b5cf6', '#f59e0b'],
    cutout: '60%',
    borderWidth: 0,
  }]
});

// ข้อมูลสำหรับ กราฟยอดตั๋วไถ่ถอน
const redeemData = ref({
  labels: ['ไถ่ถอน', 'ต่อดอก', 'เพิ่มต้น', 'ลดต้น'],
  datasets: [{
    data: [0, 0, 0, 0],
    backgroundColor: ['#f43f5e', '#10b981', '#8b5cf6', '#f59e0b'],
    cutout: '60%',
    borderWidth: 0,
  }]
});

// ข้อมูลสำหรับ สัดส่วนรายได้ดอกเบี้ย (Doughnut)
const interestData = ref({
  labels: ['ดอกเบี้ยเพิ่มต้น', 'ดอกเบี้ยไถ่ถอน','ดอกเบี้ยต่อดอก'],
  datasets: [{
    data: [0, 0, 0],
    backgroundColor: ['#8b5cf6', '#f43f5e', '#10b981'],
    cutout: '60%',
    borderWidth: 0,
    lb: ['ดอกเบี้ยเพิ่มต้น', 'ดอกเบี้ยไถ่ถอน','ดอกเบี้ยต่อดอก'],
  }]
});

// ขนาด font ตัวเลขกลาง donut — ย่อลงตามจำนวนหลัก เพื่อไม่ให้ล้นรู donut (รองรับถึงหลักร้อยล้าน)
function donutCenterFontSize(total) {
  const len = formatDecimalString(total).length
  if (len <= 10) return { fontSize: '22px' }   // ≤ 999,999.00
  if (len <= 12) return { fontSize: '19px' }   // ≤ 9,999,999.00
  if (len <= 14) return { fontSize: '16px' }   // ≤ 999,999,999.00
  return { fontSize: '14px' }
}

// ยอดรวมสำหรับแสดงตรงกลาง donut (ข้อมูลสำหรับระบบเก่า)
const pawnTicketTotal = computed(() =>
  Number(sum_mvalue.value) + Number(dataInfo.value.pawnValue) + Number(dataInfo.value.interestPawnValue) +
  Number(dataInfo.value.incPawnValue) + Number(dataInfo.value.decPawnValue))

const redeemTicketTotal = computed(() =>
  Number(dataInfo.value.redeemPawnValue) + Number(dataInfo.value.interestPawnValue) +
  Number(dataInfo.value.incPawnValue) + Number(dataInfo.value.decPawnValue))

const interestIncomeTotal = computed(() =>
  Number(dataInfo.value.incInterestAmount) + Number(dataInfo.value.redeemInterestAmount) +
  Number(dataInfo.value.interestAmount) + Number(dataInfo.value.decInterestAmount))

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  // รูกลางใหญ่ขึ้น (default 50%) ให้พอสำหรับชื่อ + ยอดรวมที่วางทับตรงกลาง
  cutout: '62%',
  plugins: {
    legend: { display: false },
    datalabels: {
      clamp: true,     // บังคับให้อยู่ภายในพื้นที่กราฟ
      overlap: false,  // สั่งให้ Plugin พยายามซ่อนตัวที่ทับกัน (ไม่การันตี 100% แต่ช่วยได้)
      // วางกลางความหนาของวงแหวน — เดิมเกาะขอบนอกแล้วเลื่อนเข้า 10px พอรูกลางใหญ่ขึ้น
      // (cutout 62%) วงบางลง ตัวเลขสีขาวเลยล้นเข้ารูสีขาวจนบางหลักหายไป
      anchor: 'center',
      align: 'center',
      offset: 0,
      padding: 4,       // เพิ่มช่องว่างรอบตัวเลข
      color: '#ffffff',
      font: {
        weight: 'bold',
        size: 12
      },
      display: (context) => {
        const dataset = context.dataset;
        const value = dataset.data[context.dataIndex];
        const total = dataset.data.reduce((acc, curr) => acc + curr, 0);
        const percentage = (value / total) * 100;

        // แสดงเฉพาะชิ้นที่มีค่ามากกว่า 5% เท่านั้น (ปรับตัวเลขได้ตามชอบ)
        return percentage > 0; 
      },
      formatter: (value, ctx) => {
        // 1. หาผลรวมทั้งหมดของ data ใน dataset นี้
        let sum = 0;
        let dataArr = ctx.chart.data.datasets[0].data;
        dataArr.map(data => {
          sum += data;
        });
        
        // 2. คำนวณหา % และปัดเศษทศนิยม
        let percentage = (value * 100 / sum).toFixed(1) + "%";
        return percentage;
      },
    }
  }
};


const optMonths = ref([
  { items: computed(() => t("opts.mon1")), value: 1 },
  { items: computed(() => t("opts.mon2")), value: 2 },
  { items: computed(() => t("opts.mon3")), value: 3 },
  { items: computed(() => t("opts.mon4")), value: 4 },
  { items: computed(() => t("opts.mon5")), value: 5 },
  { items: computed(() => t("opts.mon6")), value: 6 },
  { items: computed(() => t("opts.mon7")), value: 7 },
  { items: computed(() => t("opts.mon8")), value: 8 },
  { items: computed(() => t("opts.mon9")), value: 9 },
  { items: computed(() => t("opts.mon10")), value: 10 },
  { items: computed(() => t("opts.mon11")), value: 11 },
  { items: computed(() => t("opts.mon12")), value: 12 },
])

///// computed
const plegde = computed(() => t("content.actpawn1"))
const interest = computed(() => t("content.actpawn2"))
const addcap = computed(() => t("content.actpawn3"))
const reducecap = computed(() => t("content.actpawn4"))
const redeem = computed(() => t("content.actpawn5"))
const search = computed(() => t("buttons.sear"));


const onClickHandler = (page) => {
  updatePagination()
};

// คำนวณวันที่ย้อนหลัง 3 เดือนนับจากวันนี้ (เวลา 00:00:00)
const min_start_limit = computed(() => {
  const d = new Date();
  d.setMonth(d.getMonth() - 3);
  d.setHours(0, 0, 0, 0); // รีเซ็ตเวลาเพื่อความแม่นยำ
  return d;
});

// วันสิ้นสุดห้ามเกิน วันเริ่มต้น + 3 เดือน
const max_end_limit = computed(() => {
  if (!start_date.value) return new Date();
  const d = new Date(start_date.value);
  d.setMonth(d.getMonth() + 3);
  
  const today = new Date();
  return d > today ? today : d;
});

const loadDataInfoApi = async () => {
  const gen = ++overviewInfoGen
  overviewError.value = false
  overviewUpdatedAt.value = ''
  res_time.value = ''
  dataInfo.value.pawnValue = 0
  dataInfo.value.interestPawnValue = 0
  dataInfo.value.incPawnValue = 0
  dataInfo.value.decPawnValue = 0
  dataInfo.value.redeemPawnValue = 0
  dataInfo.value.interestAmount = 0
  dataInfo.value.incInterestAmount = 0
  dataInfo.value.decInterestAmount = 0
  dataInfo.value.redeemInterestAmount = 0
  dataInfo.value.numOfPawn = 0
  dataInfo.value.numOfInterest = 0
  dataInfo.value.numOfInc = 0
  dataInfo.value.numOfDec = 0
  dataInfo.value.numOfInterestMigration = 0
  dataInfo.value.numOfIncMigration = 0
  dataInfo.value.numOfDecMigration = 0
  dataInfo.value.numOfRedeem = 0
  dataInfo.value.numOfRedeemInterest = 0
  dataInfo.value.numOfCustomer = 0
  dataInfo.value.numOfWorkCase = 0
  dataInfo.value.numOfActiveWorkCase = 0
  dataInfo.value.numOfPostponeWorkCase = 0
  dataInfo.value.numOfVoidTicket = 0
  dataInfo.value.numOfEditAfterComplete = 0
  dataInfo.value.pawnAmount = 0
  dataInfo.value.incAmount = 0
  dataInfo.value.incDiff = 0
  dataInfo.value.decAmount = 0
  dataInfo.value.decDiff = 0
  dataInfo.value.redeemAmount = 0
  dataInfo.value.payAmount = 0
  dataInfo.value.receiveAmount = 0
  dataInfo.value.sumInterest = 0
  dataInfo.value.interestAmountMigration = 0
  dataInfo.value.interestTotalPayMigration = 0
  dataInfo.value.interestTotalReceiveMigration = 0
  dataInfo.value.incAmountMigration = 0
  dataInfo.value.incTotalPayMigration = 0
  dataInfo.value.incTotalReceiveMigration = 0
  dataInfo.value.decAmountMigration = 0
  dataInfo.value.decTotalPayMigration = 0
  dataInfo.value.decTotalReceiveMigration = 0
  dataInfo.value.totalPayMigration = 0
  dataInfo.value.totalReceiveMigration = 0
  dataInfo.value.numOfCancelTicket = 0
  dataInfo.value.numOfTerminate = 0
  dataInfo.value.numOfOtp = 0
  dataInfo.value.numOfOtpMigration = 0
  dataInfo.value.numOfRepresentWorkCase = 0
  dataInfo.value.numOfOutageWorkCase = 0
  sum_pvalue.value = 0
  sum_mvalue.value = 0;
  sum_painvalue.value = 0;
  sum_inderevalue.value = 0;
  sum_intvalue.value = 0;
  sum_pawncase.value = 0;
  sum_pawnvalue.value = 0;
  sum_redeemcase.value = 0;
  sum_redeemvalue.value = 0;
  loading.value = false
  const shopUids = scopeShops(overviewGroup.value).map((s) => s.uid);
  if (shopUids.length === 0) {
    loading.value = false;
    overviewInfoLoading.value = false;
    return;
  }
  let data = {
    fromDate: moment(new Date(start_date.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_date.value)).format('YYYY-MM-DDT23:59:59'),
    shopUids: shopUids
  };
  const payload = data;
  overviewInfoLoading.value = true
  let response = null
  try {
    response = await storedash.dashboardInfoFetch(payload);
    if (response?.status !== 200 || response?.data?.rtnDesc !== 'success' || !response?.data?.data) throw new Error('Dashboard response failed')
  } catch (error) {
    if (gen === overviewInfoGen) overviewError.value = true
    return
  } finally {
    if (gen === overviewInfoGen) overviewInfoLoading.value = false
  }
  if (gen !== overviewInfoGen) return
  // console.log('dataInfo : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res_time.value = moment(String(new Date)).local().format('HH:mm:ss')
        overviewUpdatedAt.value = moment().format('DD/MM/YYYY · HH:mm:ss')
        dataInfo.value = response.data.data;
        setnumOfTransaction()
        setnumOfAmount()
        setnumOfSum()
        setnumOfMig()
        sum_pvalue.value = dataInfo.value.pawnValue + dataInfo.value.interestPawnValue + dataInfo.value.incPawnValue
          + dataInfo.value.decPawnValue + dataInfo.value.redeemPawnValue;
        sum_mvalue.value = dataInfo.value.interestPawnValueMigration + dataInfo.value.incPawnValueMigration
          + dataInfo.value.decPawnValueMigration;
        sum_painvalue.value = dataInfo.value.pawnValue + dataInfo.value.incPawnValue
        sum_inderevalue.value = dataInfo.value.interestPawnValue + dataInfo.value.decPawnValue + dataInfo.value.redeemPawnValue;
        sum_intvalue.value = dataInfo.value.interestAmount + dataInfo.value.incInterestAmount + dataInfo.value.decInterestAmount
          + dataInfo.value.redeemInterestAmount;
        sum_pawncase.value = Number(dataInfo.value.numOfPawn) + Number(dataInfo.value.numOfInterest) + Number(dataInfo.value.numOfInc) + Number(dataInfo.value.numOfDec)
          + Number(dataInfo.value.numOfInterestMigration) + Number(dataInfo.value.numOfIncMigration) + Number(dataInfo.value.numOfDecMigration);
        sum_pawnvalue.value = dataInfo.value.pawnValue + dataInfo.value.interestPawnValue + dataInfo.value.incPawnValue
          + dataInfo.value.decPawnValue + sum_mvalue.value;
        sum_redeemcase.value = Number(dataInfo.value.numOfInterest) + Number(dataInfo.value.numOfInc) + Number(dataInfo.value.numOfDec) + Number(dataInfo.value.numOfRedeem);
        sum_redeemvalue.value = dataInfo.value.interestPawnValue + (dataInfo.value.incPawnValue - dataInfo.value.incDiff)
          + (dataInfo.value.decPawnValue + dataInfo.value.decDiff) + dataInfo.value.redeemPawnValue;
        setnumOfGraph()  
        loading.value = true
      }
    }
  }
}

// ปุ่มค้นหาใน tab ภาพรวม — refresh ทุกส่วนของหน้า ไม่ใช่แค่ dataInfo
// (จำนวนลูกค้า LINE OA ต้องโหลดแยกต่างหาก; งานค้างอยู่ที่ tab งานค้างทั้งหมด
// ซึ่งโหลดเองตอนกด tab)
async function searchDashboardInfo() {
  if (!overviewSearchAllowed()) return
  await Promise.all([loadDataInfoApi(), loadOverviewPerShop()])
}

async function loadLineCustomerCount() {
  return loadOverviewPerShop()
}

const loadDataList = async () => {
  // console.log("load dash : ", localStorage.getItem("shop_seleted"));
  if (localStorage.getItem("shoplist") !== null) {
    shopList.value = JSON.parse(localStorage.getItem("shoplist"));
    // console.log("shopList dash : ", shopList.value);
  }

  if (localStorage.getItem("shop_seleted") !== null) {
    shop_seleted.value = JSON.parse(localStorage.getItem("shop_seleted"));
    await loadDataInfoApi()
    getShopInfo()
    loadLineCustomerCount()
  } else {
    shop_seleted.value = '0'
  }
};

loadDataList();


async function getShopInfo() {
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  shop_info.value = null
  let data = "";
  data = {
    uid: key.uid,
  };
  const payload = data;
  const response = await storesh.shopInfoFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        shop_info.value = response.data.data
        // console.log('shop_info : ' + JSON.stringify(shop_info.value));
      }
    }
  }
}


const loadDataDueApi = async () => {
  let data = "";
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  data = {
    dueDate: moment(new Date()).format('YYYY-MM-DDT00:00:00'),
    shopUid: key.uid
  };
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  const response = await storedash.dashboardDueFetch(payload);
  // console.log('dueApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        dataDue.value = response.data.data;
        setseriesDue()
        loadDueListApi()
      }
    }
  }

}

const loadDueListApi = async () => {
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  currentPage.value = 1
  let data = "";
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    lastOpenDate: moment(new Date(shop_info.value.lastOpenDate)).format('YYYY-MM-DDT00:00:00'),
    shopUid: key.uid
  };
  const payload = data;
  const response = await storedash.overdueListFetch(payload);
  // console.log('DueListApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        duelist.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        // console.log('dataInfo : ' + JSON.stringify(dataInfo.value))
      }
    }
  }
}

async function updatePagination() {
  duelist.value = []
  let data = "";
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    lastOpenDate: moment(new Date(shop_info.value.lastOpenDate)).format('YYYY-MM-DDT00:00:00'),
    shopUid: shop_seleted.value.uid
  };
  const payload = data;
  const response = await storedash.overdueListFetch(payload);
  // console.log('loadDueListApi : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        duelist.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        // console.log('dataInfo : ' + JSON.stringify(dataInfo.value))
      }
    }
  }
}

function copyBtn() {
  navigator.clipboard.writeText(workcaseDetail.value.tkRefNumber);
}

const NewTab = async () => {
  sessionStorage.removeItem('deferWorkcaseUid');
  sessionStorage.setItem("deferWorkcaseUid", workcaseDetail.value.uid);
  if (sessionStorage.getItem('deferWorkcaseUid') !== null) {
    const win = window.open("#/generals/defer_items", "_blank");
    win.focus();
    sessionStorage.removeItem('deferWorkcaseUid');
  }
}


const goToRpDefer = async () => {
  if (blockedInGroupMode()) return
  sessionStorage.removeItem('deferReport');
  sessionStorage.setItem("deferReport", true);
  return window.location.assign("#/reports/report_defer");
}


const goToRpProfit = async () => {
  if (blockedInGroupMode()) return
  return window.location.assign("#/reports/report_profit");
}

const goToHistory = async (val) => {
  if (blockedInGroupMode()) return
  let data = {
    start_date: moment(new Date(start_date.value)).format('YYYY-MM-DDT00:00:00'),
    end_date: moment(new Date(end_date.value)).format('YYYY-MM-DDT23:59:59'),
    value: val
  }
  sessionStorage.removeItem('historyPage');
  sessionStorage.setItem("historyPage", JSON.stringify(data));
  return window.location.assign("#/generals/history");
}

const goToHistory_detail = async (val,channel,type) => {
  // 18/19 = ลิงก์จาก tab ภาพรวม (ที่เหลือมาจาก tab รายละเอียด ซึ่งเป็นสาขาเดียวเสมอ)
  if ((val === 18 || val === 19) && blockedInGroupMode()) return
  let start = start_datet.value
  let end = end_datet.value
  if(val === 18 || val === 19){
   start = start_date.value
   end = end_date.value
  }
  let data = {
    start_date: moment(new Date(start)).format('YYYY-MM-DDT00:00:00'),
    end_date: moment(new Date(end)).format('YYYY-MM-DDT23:59:59'),
    value: val,
    type: type,
    channel: channel
  }
  sessionStorage.removeItem('historyPage');
  sessionStorage.setItem("historyPage", JSON.stringify(data));
  return window.location.assign("#/generals/history");
}


async function selectProfile() {
  if (window.location.href.indexOf("signin") == -1) {
    if (shop_seleted.value !== null && shop_seleted.value !== '0') {
      // console.log("selectProfile dash : " + JSON.stringify(shop_seleted.value));
      const old_shop = localStorage.getItem("shop_seleted")
        ? JSON.parse(localStorage.getItem("shop_seleted"))
        : null;
      const isNewShop = !old_shop || shop_seleted.value.uid !== old_shop.uid;
      if (isNewShop) {
        // บันทึกสาขาใหม่ลง localStorage
        const lf = filterData(shop_seleted.value.uid, shopList.value);
        if (lf && lf[0]) {
          localStorage.setItem("shop_seleted", JSON.stringify(lf[0]));
        }
        // Reset การเลือกกลุ่มสาขาเมื่อเปลี่ยนสาขา
        overviewGroup.value = null;
        dueGroup.value = null;
        perShopFailed.value = [];
        // โหลดข้อมูลใหม่โดยไม่ reload หน้า
        if (overviewSearchAllowed()) {
          await Promise.all([loadDataInfoApi(), loadLineCustomerCount()]);
        }
        await getShopInfo();
      }
    }
  }
}

async function reloadPage() {
  // ถูกแทนที่โดย selectProfile() — คงฟังก์ชันไว้เพื่อไม่ให้ reference อื่น error
}

// ฟังก์ชันสำหรับเช็คว่าเป็นตัวเลขบวกและเป็นประเภท net-cash หรือไม่
const isPositiveNetCash = (item) => {
  return item.type === 'net-cash' && item.value > 0
}

const getStatusText = (item) => {
  if (item.type !== 'net-cash') return ''
  
  const value = parseFloat(item.value)
  if (value > 0) return '(เพิ่มขึ้น)'
  if (value < 0) return '(ลดลง)'
  
  return '' // หรือ return '(คงที่)' หากต้องการให้แสดงข้อความเมื่อเป็น 0
}

async function onClickTab(val) {
  if (val === '1') {
    if (overviewSearchAllowed()) {
      await loadDataInfoApi()
    }
    await setfirstTab()
  } else if (val === '2') {
    if (start_dater.value <= end_dater.value && shop_seleted.value !== null && shop_seleted.value !== '0' ) {
      await loadRedeemReportApi()
    }
    await setsecondTab()
  }else if (val === '3') {
    if (start_datet.value <= end_datet.value) {
      await searchTransactionsInfo()
    }
    await setthirdTab()
  }else if (val === '4') {
    await loadDataDueApi()
    await setfourthTab()
  }else if (val === '5') {
    await refreshWorkflowDashboard()
    await setfifthTab()
  }
}


function filterData(str, matchArr) {
  return matchArr.filter((c) => c.uid === str);
}

function changeViewGraph() { 
  if (viewGraph.value) {
    viewInfo.value = false
  } else {
    viewInfo.value = true
  }

}


function changeViewInfo() {
  if (viewInfo.value) {
    viewGraph.value = false
  } else {
    viewGraph.value = true
  }

}

function getWorkflowQueueMeta(code) {
  return workflowQueues.value.find((queue) => queue.code === code)
    || { code, label: code, color: '#6c757d' };
}

function toWorkflowNumber(value) {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
}

function workflowCashValue(row, useRounded = false) {
  const receive = useRounded ? toWorkflowNumber(row.roundTotalReceive) : toWorkflowNumber(row.totalReceive);
  const pay = useRounded ? toWorkflowNumber(row.roundTotalPay) : toWorkflowNumber(row.totalPay);

  if (receive > 0) {
    return receive;
  }
  if (pay > 0) {
    return -pay;
  }
  return 0;
}

function workflowPaymentRowForQueueItem(row) {
  return list_pay.value.find((payment) =>
    payment.workItemUid === row.uid
    || payment.workItemUid === row.workItemUid
    || payment.uid === row.paymentGroupUid
    || payment.paymentGroupUid === row.paymentGroupUid
  ) || row;
}

function workflowAgeMinutes(startTime) {
  const start = moment(String(startTime));
  if (!startTime || !start.isValid()) {
    return 0;
  }
  return Math.max(0, moment(workflowNow.value).diff(start, 'minutes'));
}

function workflowAgeText(minutes) {
  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}ชม. ${mins}น.`;
  }
  return `${minutes}น.`;
}

function normalizeWorkflowQueueItem(row, index) {
  const queueCode = row.queue?.code || '';
  const queueMeta = getWorkflowQueueMeta(queueCode);
  const transactionText = row.migration
    ? `${checkTransaction(row.type)} (${checkTransaction(row.migrationType)})`
    : checkTransaction(row.type);
  const paymentRow = row.type === 'PAYMENT' ? workflowPaymentRowForQueueItem(row) : null;
  const cashValue = row.type === 'PAYMENT'
    ? workflowCashValue(paymentRow, true)
    : workflowCashValue(row);

  return {
    key: `work-${row.uid || row.workItemUid || row.jobId || index}`,
    uid: row.uid || row.workItemUid || '',
    workCaseUid: row.workCaseUid || '',
    paymentGroupUid: workflowFirstValidUid(row.paymentGroupUid, row.paymentGrpUid, row.paymentGroup?.uid, row.paymentGrp?.uid, paymentRow?.paymentGroupUid, paymentRow?.uid),
    isPayment: row.type === 'PAYMENT',
    transactionType: row.type || '',
    queueCode,
    queueLabel: queueMeta.label,
    color: queueMeta.color,
    startTime: row.startTime,
    ageMinutes: workflowAgeMinutes(row.startTime),
    jobId: row.jobId || '-',
    transactionText,
    customerName: row.changeName ? (row.customerName || '-') : (row.tkCustomerName || row.customerName || '-'),
    oldRefNumber: row.prevRefNumber || '-',
    newRefNumber: row.refNumber || '-',
    pawnValue: toWorkflowNumber(row.newPawnValue),
    cashValue,
    ownerName: row.ownerUid !== '0' ? (row.ownerName || '-') : '-',
  };
}

const workflowTxBgMap = {
  'PAWN':          '#dbeafe',
  'INTEREST':      '#d1fae5',
  'INC_PRINCIPLE': '#ede9fe',
  'DEC_PRINCIPLE': '#fef3c7',
  'REDEEM':        '#ffe4e6',
};

const workflowTxColorMap = {
  'PAWN':          '#2563eb',
  'INTEREST':      '#059669',
  'INC_PRINCIPLE': '#7c3aed',
  'DEC_PRINCIPLE': '#d97706',
  'REDEEM':        '#e11d48',
};

function workflowWcColor(type) {
  return workflowTxColorMap[type] || '#67748e';
}

const workflowDisplayWorkCases = computed(() => {
  const allowed = new Set(['PAWN', 'INTEREST', 'INC_PRINCIPLE', 'DEC_PRINCIPLE', 'REDEEM']);
  return workflowPaymentWorkCases.value
    .filter((wc) => allowed.has(wc.transactionType))
    .slice(0, 100);
});

function workflowCardBg(item) {
  if (item.isPayment) return '#ffffff';
  return workflowTxBgMap[item.transactionType] || '#ffffff';
}

function isWorkflowWaiting(item) {
  return item.ageMinutes > 30 && item.queueCode !== 'Q04';
}

function isWorkflowVaultLong(item) {
  return item.ageMinutes > 60 && item.queueCode === 'Q04';
}

function workflowQueueCount(code) {
  return workflowFilteredItems.value.filter((item) => item.queueCode === code).length;
}

// คืน net cashValue (signed): < 0 = จ่ายออก(แดง), > 0 = รับเข้า(เขียว)
function workflowQueueCashNet(code) {
  return workflowAllItems.value
    .filter((item) => !item.isPayment && item.queueCode === code && item.cashValue !== 0)
    .reduce((sum, item) => sum + item.cashValue, 0);
}

function workflowFilteredByQueue(code) {
  return workflowFilteredItems.value.filter((item) => item.queueCode === code);
}

function selectWorkflowItem(item) {
  selectedWorkflowKey.value = item.key;
  loadWorkflowPaymentTypes(item);
  nextTick(() => {
    const el = document.getElementById('workflowDetailModal');
    if (el) {
      const modal = new Modal(el);
      modal.show();
    }
  });
}

function workflowValidUid(value) {
  const uid = value === null || value === undefined ? '' : String(value);
  return uid !== '' && uid !== '0' ? uid : '';
}

function workflowFirstValidUid(...values) {
  return values.map((value) => workflowValidUid(value)).find(Boolean) || '';
}

async function resolveWorkflowPaymentGroupUid(item) {
  const itemPaymentGroupUid = workflowFirstValidUid(
    item?.paymentGroupUid,
    item?.paymentGrpUid,
    item?.paymentGroup?.uid,
    item?.paymentGrp?.uid,
  );
  if (itemPaymentGroupUid) {
    return itemPaymentGroupUid;
  }

  const paymentRow = list_pay.value.find((payment) =>
    payment.workItemUid === item?.uid
    || payment.workItemUid === item?.workItemUid
    || payment.jobId === item?.jobId
  );
  const paymentRowGroupUid = workflowFirstValidUid(paymentRow?.paymentGroupUid, paymentRow?.paymentGrpUid, paymentRow?.paymentGroup?.uid, paymentRow?.paymentGrp?.uid, paymentRow?.uid);
  if (paymentRowGroupUid) {
    return paymentRowGroupUid;
  }

  const queueRow = await findWorkflowQueuePaymentGroupRow(item);
  const queueRowGroupUid = workflowFirstValidUid(queueRow?.paymentGroupUid, queueRow?.paymentGrpUid, queueRow?.paymentGroup?.uid, queueRow?.paymentGrp?.uid);
  if (queueRowGroupUid) {
    return queueRowGroupUid;
  }

  if (!item?.workCaseUid) {
    return '';
  }

  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  if (!key) {
    return '';
  }
  const response = await storewc.workCaseinfoAdminFetch({
    groupUid: key.groupUid,
    shopUid: key.uid,
    uid: item.workCaseUid,
  });
  const detail = response?.data?.data || {};
  return workflowFirstValidUid(detail.paymentGroupUid, detail.paymentGrpUid, detail.paymentGroup?.uid, detail.paymentGrp?.uid);
}

async function findWorkflowQueuePaymentGroupRow(item) {
  if (!item?.queueCode || !item?.jobId) {
    return null;
  }
  const fetchers = {
    Q01: storew.listQ01Fetch,
    Q02: storew.listQ02Fetch,
    Q03: storew.listQ03Fetch,
    Q04: storew.listQ04Fetch,
  };
  const fetcher = fetchers[item.queueCode];
  if (!fetcher) {
    return null;
  }
  const response = await fetcher({
    index: 0,
    size: 500,
  });
  const list = response?.data?.data?.list || [];
  return list.find((row) => row.jobId === item.jobId || row.uid === item.uid || row.workCaseUid === item.workCaseUid) || null;
}

function workflowPaymentListFromResponse(response) {
  const data = response?.data?.data;
  if (Array.isArray(data)) {
    return data;
  }
  if (Array.isArray(data?.list)) {
    return data.list;
  }
  if (Array.isArray(data?.list?.payment)) {
    return data.list.payment;
  }
  if (Array.isArray(data?.payments)) {
    return data.payments;
  }
  if (Array.isArray(data?.paymentList)) {
    return data.paymentList;
  }
  return [];
}

async function workflowPaymentGroupPayments(paymentGroupUid) {
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  const uid = workflowValidUid(paymentGroupUid);
  if (!key || !uid) {
    return [];
  }
  const response = await storep.paymentGroupInfoAdminFetch({
    groupUid: key.groupUid,
    shopUid: key.uid,
    uid,
  });
  return workflowPaymentListFromResponse(response);
}

async function loadWorkflowPaymentTypes(item) {
  workflowPaymentTypes.value = [];
  workflowPaymentWorkCases.value = [];
  workflowPaymentTypesLoading.value = false;
  if (!item) {
    return;
  }

  const selectedKey = item.key;
  workflowPaymentTypesLoading.value = true;
  try {
    const paymentGroupUid = await resolveWorkflowPaymentGroupUid(item);
    if (selectedWorkflowKey.value !== selectedKey) {
      return;
    }
    if (!paymentGroupUid) {
      workflowPaymentTypes.value = [];
      return;
    }

    const shopKey = JSON.parse(localStorage.getItem("shop_seleted"));
    const [payListResponse, grpInfoResponse] = await Promise.all([
      storepay.paymentlistFetch({ index: 0, size: 100, pguid: paymentGroupUid }),
      shopKey
        ? storep.paymentGroupInfoAdminFetch({ groupUid: shopKey.groupUid, shopUid: shopKey.uid, uid: paymentGroupUid })
        : Promise.resolve(null),
    ]);
    if (selectedWorkflowKey.value !== selectedKey) {
      return;
    }

    workflowPaymentWorkCases.value = grpInfoResponse?.data?.data?.workCases || [];

    let list = workflowPaymentListFromResponse(payListResponse);
    if (list.length === 0) {
      list = workflowPaymentListFromResponse(grpInfoResponse);
    }
    workflowPaymentTypes.value = workflowPaymentTypeSummaries(list);
  } catch (e) {
    if (selectedWorkflowKey.value === selectedKey) {
      workflowPaymentTypes.value = [];
      workflowPaymentWorkCases.value = [];
    }
  } finally {
    if (selectedWorkflowKey.value === selectedKey) {
      workflowPaymentTypesLoading.value = false;
    }
  }
}

function workflowPaymentTypeText(type) {
  const paymentType = workflowNormalizePaymentType(type);
  if (paymentType === 'CASH') {
    return t("content.amncash");
  }
  if (paymentType === 'BANK_TRANSFER') {
    return t("content.amntransfer");
  }
  if (paymentType === 'CREDIT_CARD') {
    return t("content.amncreditcard");
  }
  if (paymentType === 'CHEQUE') {
    return t("content.amncheque");
  }
  if (paymentType === 'PROMPT_PAY_MOBILE') {
    return t("content.amntransfer_promt_mobile");
  }
  if (paymentType === 'PROMPT_PAY_TAX_ID') {
    return t("content.amntransfer_promt_taxid");
  }
  if (paymentType === 'QR_CODE') {
    return 'QR Code';
  }
  return type || '-';
}

function workflowNormalizePaymentType(type) {
  return type ? String(type).trim().toUpperCase() : '';
}

function workflowPaymentTypeSummaries(list) {
  const summaries = {};
  list.forEach((row) => {
    const type = workflowNormalizePaymentType(row.type);
    if (!type) {
      return;
    }
    if (!summaries[type]) {
      summaries[type] = {
        type,
        pay: 0,
        receive: 0,
        fee: 0,
      };
    }
    summaries[type].pay += toWorkflowNumber(row.pay);
    summaries[type].receive += toWorkflowNumber(row.receive);
    summaries[type].fee += toWorkflowNumber(row.fee) + toWorkflowNumber(row.feePay) + toWorkflowNumber(row.feeReceive);
  });
  return Object.values(summaries);
}

function workflowPaymentTypeAmountParts(payment) {
  const parts = [];
  if (payment.receive > 0) {
    parts.push({ kind: 'receive', text: `รับ ${formatNumberDecimalString(payment.receive)}` });
  }
  if (payment.pay > 0) {
    parts.push({ kind: 'pay', text: `จ่าย ${formatNumberDecimalString(payment.pay)}` });
  }
  if (payment.fee > 0) {
    parts.push({ kind: 'fee', text: `ค่าธรรมเนียม ${formatNumberDecimalString(payment.fee)}` });
  }
  return parts.length > 0 ? parts : [{ kind: 'empty', text: formatNumberDecimalString(0) }];
}

function workflowCashClass(value) {
  if (value > 0) {
    return 'workflow-cash-receive';
  }
  if (value < 0) {
    return 'workflow-cash-pay';
  }
  return '';
}

function workflowCashText(value) {
  if (value === 0) {
    return '-';
  }
  return formatNumberDecimalString(Math.abs(value));
}

async function refreshWorkflowDashboard() {
  await loadAllQueueApi();
  await loadPaymentAllApi();
  res_time.value = moment(String(new Date)).local().format('HH:mm:ss');
  loadWorkflowPaymentMethodSummary();
}

async function loadWorkflowPaymentMethodSummary() {
  workflowPaymentMethodLoading.value = true;
  workflowPaymentMethodSummary.value = { payout: {}, receive: {} };
  try {
    const paymentItems = workflowAllItems.value.filter((item) => item.isPayment && item.paymentGroupUid);
    const uniqueUids = [...new Set(paymentItems.map((item) => item.paymentGroupUid).filter(Boolean))];
    const allRows = (await Promise.all(uniqueUids.map((uid) => workflowPaymentGroupPayments(uid)))).flat();
    const summary = { payout: {}, receive: {} };
    allRows.forEach((row) => {
      const type = workflowNormalizePaymentType(row.type);
      if (!type) return;
      const payAmt = toWorkflowNumber(row.pay);
      const recvAmt = toWorkflowNumber(row.receive);
      if (payAmt > 0) {
        summary.payout[type] = (summary.payout[type] || 0) + payAmt;
      }
      if (recvAmt > 0) {
        summary.receive[type] = (summary.receive[type] || 0) + recvAmt;
      }
    });
    workflowPaymentMethodSummary.value = summary;
  } catch (e) {
    // keep empty on error
  } finally {
    workflowPaymentMethodLoading.value = false;
  }
}


const loadAllQueueApi = async () => {
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  allqueuelist.value = []
  num_q01.value = 0
  num_q02.value = 0
  num_q03.value = 0
  num_q04.value = 0
  num_pay.value = 0
  list_q01.value = []
  list_q02.value = []
  list_q03.value = []
  list_q04.value = []


  let data = "";
  data = {
    index: '0',
    size: '100',
    shopUid: key.uid,
    groupUid: key.groupUid,
  };
  const payload = data;
  const response = await storew.listAllQueueFetch(payload);
  // console.log('AllQueue res : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        allqueuelist.value = response.data.data.list;

        list_q01.value = allqueuelist.value.filter((c) => c.queue !== null && c.queue.code === 'Q01');
        num_q01.value = list_q01.value.length


        list_q02.value = allqueuelist.value.filter((c) => c.queue !== null && c.queue.code === 'Q02');
        num_q02.value = list_q02.value.length


        list_q03.value = allqueuelist.value.filter((c) => c.queue !== null && c.queue.code === 'Q03');
        num_q03.value = list_q03.value.length


        list_q04.value = allqueuelist.value.filter((c) => c.queue !== null && c.queue.code === 'Q04');
        num_q04.value = list_q04.value.length

      }
    }
  }

}


const calPercent = (val, full) => {
  return (parseInt(val) * 100) / parseInt(full);
};

const fmNumber = (val) => {
  return Intl.NumberFormat("en-US").format(val)
}

const format = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY');
}

const textInputOptions = {
  format: 'dd/MM/yyyy'
};

function monthDiff() {
  let pro = false
  var months;
  months = (end_date.value.getFullYear() - start_date.value.getFullYear()) * 12;
  months += end_date.value.getMonth() - start_date.value.getMonth();

  if (months > 3) {
    pro = true
  }
  return pro
}

async function setnumOfTransaction() {
  legendTimes.value = [
    {
      bg: "bg-pledge",
      hd: computed(() => t("content.actpawn1")),
      dt: Number(dataInfo.value.numOfPawn),
    },
    {
      bg: "bg-interest",
      hd: computed(() => t("content.actpawn2")),
      dt: Number(dataInfo.value.numOfInterest),
    },
    {
      bg: "bg-add-cap",
      hd: computed(() => t("content.actpawn3")),
      dt: Number(dataInfo.value.numOfInc),
    },
    {
      bg: "bg-reduce-cap",
      hd: computed(() => t("content.actpawn4")),
      dt: Number(dataInfo.value.numOfDec),
    },
    {
      bg: "bg-redeem",
      hd: computed(() => t("content.actpawn5")),
      dt: Number(dataInfo.value.numOfRedeem),
    },
  ];


}

async function setnumOfAmount() {
  legendBaht.value = [
    {
      bg: "bg-pledge",
      hd: computed(() => t("content.actpawn1")),
      dt: Number(dataInfo.value.pawnAmount)
    },
    {
      bg: "bg-interest",
      hd: computed(() => t("content.actpawn2")),
      dt: Number(dataInfo.value.interestAmount),
    },
    {
      bg: "bg-add-cap",
      hd: computed(() => t("content.actpawn3")),
      dt: Number(dataInfo.value.incAmount),
    },
    {
      bg: "bg-reduce-cap",
      hd: computed(() => t("content.actpawn4")),
      dt: Number(dataInfo.value.decAmount),
    },
    {
      bg: "bg-redeem",
      hd: computed(() => t("content.actpawn5")),
      dt: Number(dataInfo.value.redeemAmount),
    },
  ];
}


async function setnumOfSum() {

  legendSum.value = [
    {
      bg: "bg-payment",
      hd: computed(() => t("content.amnoutcome")),
      dt: Number(dataInfo.value.pawnAmount) + Number(dataInfo.value.incAmount)
    },
    {
      bg: "bg-receive",
      hd: computed(() => t("content.amnincome")),
      dt: Number(dataInfo.value.decAmount) + Number(dataInfo.value.redeemAmount) + Number(dataInfo.value.interestAmount)
    },
    {
      bg: "bg-interest",
      hd: computed(() => t("content.amninterest")),
      dt: Number(dataInfo.value.sumInterest),
    },

  ];

}

async function setnumOfMig() {

  legendMig.value = [
    {
      bg: "bg-interest",
      hd: computed(() => t("content.actpawn2")),
      dt: Number(dataInfo.value.interestAmountMigration),
      dt2: Number(dataInfo.value.numOfInterestMigration),
    },
    {
      bg: "bg-add-cap",
      hd: computed(() => t("content.actpawn3")),
      dt: Number(dataInfo.value.incAmountMigration),
      dt2: Number(dataInfo.value.numOfIncMigration),
    },
    {
      bg: "bg-reduce-cap",
      hd: computed(() => t("content.actpawn4")),
      dt: Number(dataInfo.value.decAmountMigration),
      dt2: Number(dataInfo.value.numOfDecMigration),
    },

  ];

}


async function setnumOfGraph() {
  let sub_case = Number(sum_pawncase.value)-Number(sum_redeemcase.value)
  let sub_val =  Number(sum_redeemvalue.value) - Number(sum_pawnvalue.value)
  let red  = false
  if (sub_case < 0) {
    red = true
  }

  stats.value = [
  {
    label: 'ยอดตั๋วจํานํา (เข้า)',
    value: sum_pawnvalue.value,
    subPrefix: 'จำนวน:',
    subText: formatNumberString(sum_pawncase.value),
    subUnit: 'เบอร์',
    icon: 'volunteer_activism',
    type: 'pawn-in'
  },
  {
    label: 'ยอดตั๋วไถ่ถอน (ออก)',
    value: sum_redeemvalue.value,
    subPrefix: 'จำนวน:',
    subText: formatNumberString(sum_redeemcase.value),
    subUnit: 'เบอร์',
    icon: 'payments',
    type: 'pawn-out'
  },
  {
    label: 'รายได้ดอกเบี้ยรวม',
    value: sum_intvalue.value,
    subPrefix: '',
    subText: '',
    subUnit: '',
    icon: 'fas fa-coins',
    type: 'interest'
  },
  {
    label: 'เงินสุทธิวันนี้',
    value: sub_val,
    subPrefix: 'สต๊อกสุทธิ:',
    subText: formatNumberString(sub_case),
    subUnit: 'รายการ',
    isRed: red,
    icon: 'fas fa-chart-line',
    type: 'net-cash'
  }
]

let tt_pawn = Number(sum_mvalue.value)+Number(dataInfo.value.pawnValue)

pawnData.value = {
  labels: ['จํานำ', 'ต่อดอก', 'เพิ่มต้น', 'ลดต้น'],
  datasets: [{
    data: [tt_pawn, dataInfo.value.interestPawnValue, dataInfo.value.incPawnValue, dataInfo.value.decPawnValue],
    backgroundColor: ['#3b82f6', '#10b981', '#8b5cf6', '#f59e0b'],
    cutout: '60%',
    borderWidth: 1,
  },
  ]
}


// ข้อมูลสำหรับ กราฟยอดตั๋วไถ่ถอน
redeemData.value = {
  labels: ['ไถ่ถอน', 'ต่อดอก', 'เพิ่มต้น', 'ลดต้น'],
  datasets: [{
    data: [dataInfo.value.redeemPawnValue, dataInfo.value.interestPawnValue, dataInfo.value.incPawnValue, dataInfo.value.decPawnValue],
    backgroundColor: ['#f43f5e', '#10b981', '#8b5cf6', '#f59e0b'],
    cutout: '60%',
    borderWidth:1,
  }]
};

// ข้อมูลสำหรับ สัดส่วนรายได้ดอกเบี้ย (Doughnut)
  interestData.value = {
  labels: ['ดอกเบี้ยเพิ่มต้น', 'ดอกเบี้ยไถ่ถอน','ดอกเบี้ยต่อดอก','ดอกเบี้ยลดต้น'],
  datasets: [{
    data: [dataInfo.value.incInterestAmount, dataInfo.value.redeemInterestAmount, dataInfo.value.interestAmount , dataInfo.value.decInterestAmount],
    backgroundColor: ['#8b5cf6', '#f43f5e', '#10b981', '#f59e0b'],
    cutout: '60%',
    borderWidth: 1,
    lb: ['ดอกเบี้ยเพิ่มต้น', 'ดอกเบี้ยไถ่ถอน','ดอกเบี้ยต่อดอก','ดอกเบี้ยลดต้น'],
  }]
};


}


async function setseriesDue() {
  let totaldue = Number(dataDue.value.clearToday) + Number(dataDue.value.notClearToday)
  legendDue.value = [
    {
      hd: computed(() => t("content.amnticketdueactived")),
      vs: Number(dataDue.value.clearToday),
      vm: Number(totaldue),
      tx: "text-primary",
      bg: "bg-primary",
    },
    {
      hd: computed(() => t("content.amnticketdued")),
      vs: Number(dataDue.value.notClearToday),
      vm: Number(totaldue),
      tx: "text-warning",
      bg: "bg-warning",
    },
    // {
    //   hd: computed(() => t("content.amnticketoveractived")),
    //   vs: Number(dataDue.value.overdue),
    //   vm: Number(dataDue.value.overdueTotal),
    //   tx: "text-danger",
    //   bg: "bg-danger",
    // },
    {
      hd: computed(() => t("content.amnticketoverd")),
      vs: Number(dataDue.value.overdueClearToday),
      vm: Number(dataDue.value.overdueCount),
      tx: "text-secondary",
      bg: "bg-secondary",
    },
  ];

}

function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatDecimalString(num) {
  num = Number(num)
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatNumberString(num) {
  num = Number(num)
  if (num === null || num === undefined) {
    num = 0
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );

}


function format_time(value) {
  if (value) {
    return moment(String(value)).local().format('HH:mm:ss')
  }
}


function checkTransaction(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอกเบี้ย'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  }else if (str === 'PAYMENT') {
    side = 'การชำระ'
  }else if (str === 'REVIEW_COLLATERAL') {
      side = 'ขอดูทรัพย์'
  }
  return side
}

function checkTransaction2(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอก'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  }else if (str === 'PAYMENT') {
    side = 'การชำระ'
  }else if (str === 'REVIEW_COLLATERAL') {
      side = 'ขอดูทรัพย์'
  }
  return side
}

function filterMonths(str) {
  let side = ''
  let name = optMonths.value.filter((c) => c.value === str);
  if (name.length > 0) {
    side = name[0].items
  }
  return side
}

function setyears(year) {
  return Number(year) + 543
}



async function viewUserWorkDetail(val) {
  if (blockedInGroupMode()) return
  userq.value = val
  list_userq.value = []
  if (userq.value === 'Q01') {
    list_userq.value = list_q01.value
  } else if (userq.value === 'Q02') {
    list_userq.value = list_q02.value
  } else if (userq.value === 'Q03') {
    list_userq.value = list_q03.value
  } else if (userq.value === 'Q04') {
    list_userq.value = list_q04.value
  } else if (userq.value === 'QPAY') {
    list_userq.value = list_pay.value
  }

  document.getElementById("userWorkModalShow").click();
}


const loadPaymentAllApi = async () => {
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  list_pay.value = []
  let data = "";
  data = {
    index: 0,
    size: 100,
    groupUid: key.groupUid,
    shopUid: key.uid,
  };
  const payload = data;
  const response = await storedash.listPaymentAllFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        list_pay.value = response.data.data.list;
        num_pay.value = list_pay.value.length
      }
    }
  }
}

function filterUserOwner(str) {
  let ld = allqueuelist.value.filter((c) => c.uid === str && c.type === 'PAYMENT')
  // console.log('filterUserOwner : ' + JSON.stringify(ld))
  let name = ''
  if (ld.length > 0) {
    name = ld[0].ownerName
  }
  return name
}


async function getCollecteral(uid, val, swalTarget = '#detailUserWorkModal') {
  detailShop.value = null
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  coll_l.value = []
  let detail = null
  let data = {
    uid: uid,
    groupUid: key.groupUid,
    shopUid: key.uid,
  };
  const payload = data;
  const response = await storewc.workCaseinfoAdminFetch(payload);
  // console.log("getwc : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        detail = response.data.data
        if (val === 'coll') {
          const items1 = [];

        if (detail.ticket.collaterals.length > 0) {
          for (var i = 0; i < detail.ticket.collaterals.length; i++) {
            items1.push(detail.ticket.collaterals[i].remark);
          }

          swal({
            title: 'ข้อมูลรายละเอียดทรัพย์',
            text: '',
            icon: '',
            width: 900, // Accepts a number (pixels)
            html: ` <pre></pre>
                    <ol style="text-align: left;">
                      <pre></pre>
                      ${items1.map(item => `<li>${item}</li>`).join('')}
                      <pre></pre>
                    </ol>
                    <pre></pre>
                  `,
            target: swalTarget,
            customClass: {
              container: 'loading-state'
            },
          })
        } else {
          swal({
            title: 'ไม่มีข้อมูลรายละเอียดทรัพย์',
            text: '',
            icon: 'warning',
            button: t('button.confirm'),
            target: swalTarget,
            customClass: {
              container: 'loading-state'
            },
          })
        }

      }else if(val === 'img'){
          jobId.value = detail.workItems[0].jobId
          images.value = []
          images_l.value = []
          images_l.value = detail.ticket.images
          if(images_l.value.length > 0){
            getTicketImage()
          }else {
            swal({
              title: 'ไม่มีข้อมูลรูปทรัพย์',
              text: '',
              icon: 'warning',
              button: t('button.confirm'),
              target: swalTarget,
              customClass: {
                container: 'loading-state'
              },
            })
          }
        }
      }
    }
  }
}

async function getCollecteralFromWorkflowModal(uid, val) {
  const modalEl = document.getElementById('workflowDetailModal');
  if (modalEl && modalEl.classList.contains('show')) {
    const instance = Modal.getInstance(modalEl) || new Modal(modalEl);
    instance.hide();
    await new Promise(resolve => setTimeout(resolve, 400));
  }
  await getCollecteral(uid, val, 'body');
}

async function openWorkflowCardAsset(item, val) {
  if (!item || item.isPayment || !item.workCaseUid) {
    return;
  }
  await getCollecteral(item.workCaseUid, val, 'body');
}


async function getTicketImage() {
  loading_i.value = true;
  images.value = [];

  // 1. กรองเอาเฉพาะรายการที่มี imageUid จริงๆ (ไม่เป็น "0")
  const validFiles = images_l.value.filter(file => file.imageUid && file.imageUid !== "0");

  if (validFiles.length > 0) {
    // 🟢 2. วนลูปสร้าง Requests ในรูปแบบ POST Payload
    const requests = validFiles.map((fileItem) => {
      // ดึงคีย์เซสชันร้านค้าของหน้านี้ (ตรวจสอบชื่อ key ใน localStorage ของหน้านี้ให้ตรงนะครับ เช่น shop_seleted หรือคำอื่น)
      const keyStorage = JSON.parse(localStorage.getItem("shop_seleted"));
      
      const payload = {
        groupUid: keyStorage?.groupUid || "", 
        shopUid: keyStorage?.uid || "",  
        uid: String(fileItem.imageUid)
      };
      // เรียกใช้ผ่าน Store ส่วนกลางที่แก้เป็น POST ไว้แล้ว [INDEX]
      return stored.getFileFetch(payload); // 💡 ตรวจสอบชื่อตัวแปร store ของหน้านี้ให้ตรงนะครับ เช่น stored หรือ storedoc
    });

    try {
      // 🟢 3. ยิงดาวน์โหลดทุกไฟล์พร้อมกันแบบขนานด้วย Promise.all [INDEX]
      const allResults = await Promise.all(requests);
      
      if (allResults) {
        for (let i = 0; i < allResults.length; i++) {
          if (allResults[i] && allResults[i].status === 200 && allResults[i].data !== null) {
            const rawData = allResults[i].data;
            const isBlob = rawData instanceof Blob || (rawData && rawData.size !== undefined);
            
            if (isBlob) {
              // สแกนตรวจสอบเนื้อไฟล์จริง (Magic Numbers)
              const textHead = await rawData.slice(0, 4).text();
              let cleanBlob;
              let fileType;

              if (textHead === "%PDF") {
                cleanBlob = new Blob([rawData], { type: 'application/pdf' });
                fileType = 'application/pdf';
              } else if (textHead.startsWith("PK")) {
                cleanBlob = new Blob([rawData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              } else {
                // 🖼️ สลัดหัวคำสั่งดาวน์โหลดทิ้ง บังคับครอบหัวภาพใหม่ให้สะอาด 100%
                cleanBlob = new Blob([rawData], { type: 'image/jpeg' });
                fileType = 'image/jpeg';
              }

              const dataUrl = URL.createObjectURL(cleanBlob);
              const originalItem = validFiles[i];

              images.value.push({
                src: dataUrl,
                thumbnailImageSrc: dataUrl,
                alt: '',
                title: fileType, 
                filename: 'attachment_' + originalItem.imageUid, 
                uid: originalItem.uid,
                imageUid: originalItem.imageUid,
                rawBlob: cleanBlob 
              });
            }
          }
        }
      }
    } catch (e) {
      console.error("Error in Promise.all getTicketImage:", e);
      loading_i.value = false;
      return;
    }
  }

  // แผนสำรอง: ถ้าดึงออกมาแล้วไม่มีรูปแนบอยู่จริง ให้ยัดรูปภาพทดแทน (No Image) ตามเงื่อนไขเดิมของคุณ
  if (images.value.length === 0) {
    images.value.push({
      src: noImg,
      thumbnailImageSrc: noImg,
      alt: '',
      title: ''
    });
  }

  // 🟢 4. แยกเส้นทางการพรีวิวและเปิดใช้งานป๊อปอัปตามประเภทไฟล์จริง (หยิบตัวแรกมาตรวจสอบ)
  try {
    const targetFile = images.value[0];
    const fileType = targetFile.title || "";
    const fileSrc = targetFile.src || "";

    if (fileType === 'application/pdf') {
      // 📄 กรณีเป็น PDF -> ดีดเปิดแท็บใหม่ทันที
      loading_i.value = false;
      window.open(fileSrc, '_blank');

    } else if (fileType.includes('spreadsheetml') || fileType.includes('excel')) {
      // 📊 กรณีเป็น Excel -> สั่งดาวน์โหลดลงเครื่องทันทีพร้อมชื่อที่สั้นและอ่านง่าย
      loading_i.value = false;
      let today = moment(new Date()).local().format('YYYYMMDD_HHmmss');
      let fileNameDownload = `excel_${today}.xlsx`;
      
      const link = document.createElement('a');
      link.href = fileSrc;
      link.setAttribute('download', fileNameDownload);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } else {
      // 🖼️ กรณีเป็นรูปภาพปกติ หรือรูปภาพว่างเปล่า (noImg) -> เปิดตัว Modal ของ Bootstrap หน้านี้ตามลอจิกเดิมของคุณ
      setGalleryModal();
      await nextTick();
      const myModal = document.getElementById('galleryDetailModal');
      if (myModal && typeof Modal !== "undefined") {
        Modal.getOrCreateInstance(myModal).show();
      }
      loading_i.value = false;
    }
  } catch (err) {
    console.error("Error displaying files:", err);
    loading_i.value = false;
  }
}


function setGalleryModal() {

  var i, y = "";

  for (i = 0; i < images.value.length; i++) {

    if (i == 0) {
      y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
        ' class="active" aria-current="true" aria-label="Slide ' + Number(i + 1) + '"> </button >';
    } else {
      y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
        ' aria-label="Slide ' + Number(i + 1) + '"> </button >';
    }

  }
  document.getElementById("demo2").innerHTML = y;
}

async function setfirstTab() {
  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3-tab")) {
    document.getElementById("tab3-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3")) {
    document.getElementById("tab3").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4-tab")) {
    document.getElementById("tab4-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4")) {
    document.getElementById("tab4").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5-tab")) {
    document.getElementById("tab5-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5")) {
    document.getElementById("tab5").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.add('show', 'active')
  }
}


async function setsecondTab() {

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3-tab")) {
    document.getElementById("tab3-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3")) {
    document.getElementById("tab3").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4-tab")) {
    document.getElementById("tab4-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4")) {
    document.getElementById("tab4").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5-tab")) {
    document.getElementById("tab5-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5")) {
    document.getElementById("tab5").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.add('show', 'active')
  }
}

async function setthirdTab() {
  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4-tab")) {
    document.getElementById("tab4-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4")) {
    document.getElementById("tab4").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5-tab")) {
    document.getElementById("tab5-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5")) {
    document.getElementById("tab5").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3-tab")) {
    document.getElementById("tab3-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab3")) {
    document.getElementById("tab3").classList.add('show', 'active')
  }
}


async function setfourthTab() {
  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3-tab")) {
    document.getElementById("tab3-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3")) {
    document.getElementById("tab3").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5-tab")) {
    document.getElementById("tab5-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5")) {
    document.getElementById("tab5").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4-tab")) {
    document.getElementById("tab4-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab4")) {
    document.getElementById("tab4").classList.add('show', 'active')
  }
}

async function setfifthTab() {
  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3-tab")) {
    document.getElementById("tab3-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3")) {
    document.getElementById("tab3").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4-tab")) {
    document.getElementById("tab4-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4")) {
    document.getElementById("tab4").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5-tab")) {
    document.getElementById("tab5-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab5")) {
    document.getElementById("tab5").classList.add('show', 'active')
  }
}


const loadRedeemReportApi = async () => {
  totalTicket.value = 0;
  totalInterest.value = 0;
  totalPawnValue.value = 0;
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  let data = "";
  data = {
    fromDate: moment(new Date(start_dater.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_dater.value)).format('YYYY-MM-DDT23:59:59'),
    shopUid: key.uid
  };
  const payload = data;
  const response = await storedash.redeemReportFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        reportlist.value = response.data.data.list;
        totalTicket.value = response.data.data.ext.totalTicket;
        totalInterest.value = response.data.data.ext.totalInterest;
        totalPawnValue.value = response.data.data.ext.totalPawnValue;

      }
    }
  }
}

async function searchTransactionsInfo() {
  tranlist.value = []
  normalDetail.value = null
  migrationDetail.value = null
  outageDetail.value = null
  outageMigrationDetail.value = null
  lineDetail.value = null
  summaryDetail.value = null
  graphDataDetail.value = null
  q04DataDetail.value = null

  await getNormalInfo()
  await getMigrationInfo()
  await getOutageInfo()
  await getOutageMigrationInfo()
  await getLineInfo()
  await getQ04DataInfo()
  await getSummaryInfo()
  await getGraphDataInfo()

  if (normalDetail.value != null && normalDetail.value.length > 0) {
    if (normalDetail.value.length > 0) {
          const result = normalDetail.value.map((item, i) => ({
            ...item,                 // กระจายค่าเดิมทั้งหมดออกมา (ไม่ต้องมีครอบ name)
            channel:'normal', // เพิ่ม channel เข้าไป
          }));
          tranlist.value.push(...result);      
    }    
    
  }
  if(migrationDetail.value != null && migrationDetail.value.length > 0){
    if (migrationDetail.value.length > 0) {
          const result = migrationDetail.value.map((item, i) => ({
            ...item,                 // กระจายค่าเดิมทั้งหมดออกมา (ไม่ต้องมีครอบ name)
            channel: 'migration', // เพิ่ม channel เข้าไป
            type: item.migrationType,
          }));
          tranlist.value.push(...result);      
    } 
  }

  if (outageDetail.value != null && outageDetail.value.length > 0) {
    if (outageDetail.value.length > 0) {
            const result = outageDetail.value.map((item, i) => ({
              ...item,                 // กระจายค่าเดิมทั้งหมดออกมา (ไม่ต้องมีครอบ name)
              channel:'outage', // เพิ่ม channel เข้าไป
            }));
            tranlist.value.push(...result);      
    }   
  }

 if (outageMigrationDetail.value != null && outageMigrationDetail.value.length > 0) {
    if (outageMigrationDetail.value.length > 0) {
            const result = outageMigrationDetail.value.map((item, i) => ({
              ...item,                 // กระจายค่าเดิมทั้งหมดออกมา (ไม่ต้องมีครอบ name)
              channel:'outage-migration', // เพิ่ม channel เข้าไป
              type: item.migrationType,
            }));
            tranlist.value.push(...result);      
    }   
  }


  if(lineDetail.value != null && lineDetail.value.length > 0){
    if (lineDetail.value.length > 0) {
            const result = lineDetail.value.map((item, i) => ({
              ...item,                 // กระจายค่าเดิมทั้งหมดออกมา (ไม่ต้องมีครอบ name)
              channel:'line', // เพิ่ม channel เข้าไป
            }));
            tranlist.value.push(...result);      
    } 
  }

  if(q04DataDetail.value != null && q04DataDetail.value.length > 0){
    if (q04DataDetail.value.length > 0) {
            const result = q04DataDetail.value.map((item, i) => ({
              ...item,                 // กระจายค่าเดิมทั้งหมดออกมา (ไม่ต้องมีครอบ name)
              channel:'q04', // เพิ่ม channel เข้าไป
            }));
            tranlist.value.push(...result);      
    } 
  }


  if (tranlist.value && tranlist.value.length > 0) {
      // 1. กำหนดลำดับ Channel
      const channelOrder = {
        "normal": 1,
        "migration": 2,
        "outage": 3,
        "outage-migration": 4,
        "line": 5,
        "q04": 6
      };

      // 2. กำหนดลำดับ Type
      const typeOrder = {
        "PAWN": 1,
        "INTEREST": 2,
        "INC_PRINCIPLE": 3,
        "DEC_PRINCIPLE": 4,
        "REDEEM": 5
      };

      // 3. Sort ตาม Channel ก่อน แล้วตามด้วย Type
      tranlist.value.sort((a, b) => {
        // เรียงตาม Channel ที่กำหนด
        const orderA = channelOrder[a.channel] || 99;
        const orderB = channelOrder[b.channel] || 99;
        
        if (orderA !== orderB) {
          return orderA - orderB;
        }

        // ถ้า Channel เดียวกัน ให้เรียงตาม Type
        const tOrderA = typeOrder[a.type] || 99;
        const tOrderB = typeOrder[b.type] || 99;
        return tOrderA - tOrderB;
      });

      // 4. ทำ Grouping Flag ตาม channel
      tranlist.value = tranlist.value.map((item, index, array) => {
        return {
          ...item,
          isFirstInGroup: index === 0 || item.channel !== array[index - 1].channel,
          isLastInGroup: index === array.length - 1 || item.channel !== array[index + 1].channel
        };
      });
  }

  // console.log('tranlist : ' + JSON.stringify(tranlist.value))
}

async function getNormalInfo() {
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  let data = "";
  data = {
    shopUid: key.uid,
    groupUid: key.groupUid,
    fromDate: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
  };
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  const response = await storetr.getNormalFetch(payload);
  // console.log('dueApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        normalDetail.value = response.data.data;
      }
    }
  }
}

async function getMigrationInfo() {
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  let data = "";
  data = {
    shopUid: key.uid,
    groupUid: key.groupUid,
    fromDate: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
  };
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  const response = await storetr.getMigrationFetch(payload);
  // console.log('dueApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
         migrationDetail.value = response.data.data;
      }
    }
  }
}

async function getOutageInfo() {
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  let data = "";
  data = {
    shopUid: key.uid,
    groupUid: key.groupUid,
    fromDate: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
  };
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  const response = await storetr.getOutageFetch(payload);
  // console.log('dueApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
          outageDetail.value = response.data.data;
      }
    }
  }
}

async function getOutageMigrationInfo() {
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  let data = "";
  data = {
    shopUid: key.uid,
    groupUid: key.groupUid,
    fromDate: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
  };
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  const response = await storetr.getOutageMigrationFetch(payload);
  // console.log('dueApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
          outageMigrationDetail.value = response.data.data;
      }
    }
  }
}

async function getLineInfo() {
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  let data = "";
  data = {
    shopUid: key.uid,
    groupUid: key.groupUid,
    fromDate: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
  };
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  const response = await storetr.getLineFetch(payload);
  // console.log('dueApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
         lineDetail.value = response.data.data;
      }
    }
  }
}

async function getSummaryInfo() {
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  let data = "";
  data = {
    shopUid: key.uid,
    groupUid: key.groupUid,
    fromDate: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
  };
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  const response = await storetr.getSummaryFetch(payload);
  // console.log('dueApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
          summaryDetail.value = response.data.data;
      }
    }
  }
}

async function getGraphDataInfo() {
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  let data = "";
  data = {
    shopUid: key.uid,
    groupUid: key.groupUid,
    fromDate: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
  };
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  const response = await storetr.getGraphDataFetch(payload);
  // console.log('dueApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        const result = fillEvery30Minutes(response.data.data);
        graphDataDetail.value = result;
        //console.log(result);
      }
    }
  }
}

async function getQ04DataInfo() { 
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  let data = "";
  data = {
    shopUid: key.uid,
    groupUid: key.groupUid,
    fromDate: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
  };
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  const response = await storetr.getQ04DataFetch(payload);
  // console.log('dueApi r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
         q04DataDetail.value = response.data.data;
      }
    }
  }
}

async function getCatDetailInfo(item) {
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  let data = "";
  data = {
    shopUid: key.uid,
    groupUid: key.groupUid,
    fromDate: moment(new Date(start_datet.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_datet.value)).format('YYYY-MM-DDT23:59:59'),
    type: item.type,
    migrationType: item.migrationType,
  };
  
  const payload = data;
  // console.log('dueApi p : ' + JSON.stringify(payload))
  let response = null

  if (item.channel === 'normal') {
    response = await storetr.getNormalCatDetailFetch(payload);
  }else if (item.channel === 'migration') {
    response = await storetr.getMigrationCatDetailFetch(payload);
  }else if (item.channel === 'outage') {
    response = await storetr.getOutageCatDetailFetch(payload);
  }else if (item.channel === 'outage-migration') {
    response = await storetr.getOutageMigrationCatDetailFetch(payload);
  }else if (item.channel === 'line') {
    response = await storetr.getLineCatDetailFetch(payload);
  }
  // console.log('cat r : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // 1. ปรับการแมปข้อมูลโดยกำหนด width เป็น % หรือ px
        const items1 = response.data.data.map(item => `
            <div style="display: flex;">
                <span style="width: 35%;">${item.catName}</span>
                <span style="width: 20%;color: #777;">จำนวน</span>
                <span style="width: 20%;color: blue;">
                    <b>${item.amount}</b>
                </span>
                <span style="width: 10%;color: #777;">รายการ</span>
            </div>
        `);

        // 2. เรียกใช้ swal
        swal({
          title: 'ข้อมูลรายละเอียดทรัพย์',
          width: 700,
          html: items1.length > 0 
            ? `<ol style="text-align: left; line-height: 1.8;">${items1.map(text => `<li>${text}</li>`).join('')}</ol>`
            : '<p style="color: #888;">ไม่พบข้อมูลรายละเอียดทรัพย์</p>',
        });
      }
    }
  }
}



function fillEvery30Minutes(data) {
    const fullData = [...data];
    const existingTimes = new Set(data.map(item => item.time));

    // 1. กำหนดลำดับความสำคัญของ Type
    const typeOrder = {
        "PAWN": 1,
        "INTEREST": 2,
        "INC_PRINCIPLE": 3,
        "DEC_PRINCIPLE": 4,
        "REDEEM": 5
    };

    // 2. เติมเวลาที่ขาดหายไป (00:00 - 23:30)
    for (let h = 0; h < 24; h++) {
        [0, 30].forEach(m => {
            const timeSlot = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:00`;
            
            if (!existingTimes.has(timeSlot)) {
                fullData.push({
                    time: timeSlot,
                    type: "", // หรือใส่ Default Type ที่ต้องการ
                    total: 0,
                    pawnValue: 0,
                    idNoOtp: 0,
                    idOtp: 0,
                    noIdNoOtp: 0,
                    noIdOtp: 0,
                    shopRepresent: 0
                });
            }
        });
    }

    // 3. Sort ตามเวลา และตาม Type ที่กำหนด
    return fullData.sort((a, b) => {
        // เรียงตามเวลาก่อน
        const timeCompare = a.time.localeCompare(b.time);
        if (timeCompare !== 0) return timeCompare;

        // ถ้าเวลาเดียวกัน ให้เรียงตาม Type Order (ถ้าไม่มีใน list ให้ไปอยู่ท้ายสุด)
        const orderA = typeOrder[a.type] || 99;
        const orderB = typeOrder[b.type] || 99;
        return orderA - orderB;
    });
}


async function openDetail(item) {
  // โหมดกลุ่ม: แถวจาก overdue/list ไม่มี shopUid — หาสาขาจากรหัสนำหน้าเลขตั๋ว
  const member = memberForRefNumber(dueGroup.value, item.refNumber)
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  detailShop.value = member ? { ...key, uid: member.shopUid } : null
  workcaseDetail.value = null
  images.value = []
  images_l.value = []
  listinfo.value = []
  tk_status.value = ''
  int_cal.value = 0
  paymentE.value = ''
  int_period.value = ''
  fcusdt.value = false
  dep_ref.value = ''
  bf_changename.value = ''
  af_changename.value = ''
  transdate_prv.value = null
  promotionDetail.value = null

  await getworkCaseInfo(item.refNumber)
  if (workcaseDetail.value != null) {

    if (workcaseDetail.value.changeName ) {
      af_changename.value = item.cusName
      getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
    }else { 
      if (workcaseDetail.value.transactionType !== 'PAWN') { 
          getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
      }
    }

    if (workcaseDetail.value.deposit) {
      getDepositInfo(workcaseDetail.value.tkRefNumber)
    }
    detailPayment(workcaseDetail.value.paymentGroupUid)

    images_l.value = workcaseDetail.value.ticket.images
    listinfo.value = workcaseDetail.value.ticket.collaterals

    if (workcaseDetail.value.promotionUid !== '0') { 
          retrieveInfo(workcaseDetail.value)
    }

    if (workcaseDetail.value.transactionType !== 'REDEEM') {
      if(workcaseDetail.value.latest){
        calIntInt()
      }
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ปกติ'
      } else if (workcaseDetail.value.status === 'FREEZE') {
        tk_status.value = 'อายัด'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      } else if (workcaseDetail.value.status === 'ACTIVE') {
        tk_status.value = 'กำลังดำเนินการ'
      } else if (workcaseDetail.value.status === 'BREAKING') {
        tk_status.value = 'ของหลุด'
      }

    } else {
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ไถ่ถอน'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      }
    }
    if (images_l.value.length > 0) {
      getTicketImaged()
      await nextTick();
      document.getElementById("detailModal").click();
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      await nextTick();
      document.getElementById("detailModal").click();

    }
  }
}

async function getTicketImaged() {
  images.value = []
  loading.value = true // ตั้งค่าเปิดสถานะ Loading ไว้ก่อน

  // 1. กรองเอาเฉพาะรายการที่มี imageUid จริงๆ (ไม่เป็น "0")
  const validFiles = images_l.value.filter(file => file.imageUid && file.imageUid !== "0");

  if (validFiles.length > 0) {
    // 🟢 2. วนลูปสร้าง Requests ในรูปแบบ POST Payload เพื่อส่งเข้าหา API ส่วนกลาง
    const requests = validFiles.map((fileItem) => {
      // ดึงคีย์ข้อมูลร้านค้าจาก localStorage (ตรวจสอบชื่อคีย์ของหน้านี้ให้ตรงนะครับ เช่น shop_seleted)
      // โหมดกลุ่มสาขา: ใช้สาขาของตั๋วที่เปิดดู (detailShopKey) ไม่ใช่สาขาที่เลือก
      const keyStorage = detailShopKey();
      
      const payload = {
        groupUid: keyStorage?.groupUid || "", // ส่งค่าว่าง หรือระบุตัวแปรที่ดักกรุ๊ปของหน้านี้ (ถ้ามี)
        shopUid: keyStorage?.uid || "",  // ดึงจาก shop_seleted.uid 
        uid: String(fileItem.imageUid) // รหัสไอดีของไฟล์แนบ
      };
      // เรียกใช้ผ่านฟังก์ชัน store ส่วนกลางที่คุณปรับปรุงเป็น POST ไว้เรียบร้อยแล้ว [INDEX]
      return stored.getFileFetch(payload); // 💡 ตรวจสอบชื่อตัวแปร store ของหน้านี้ให้ตรงนะครับ เช่น stored หรือ storedoc
    });

    try {
      // 🟢 3. ยิงขนานดึงทุกไฟล์ขึ้นมาพร้อมกันรวดเดียวด้วย Promise.all [INDEX]
      const allResults = await Promise.all(requests);
      
      if (allResults) {
        for (let i = 0; i < allResults.length; i++) {
          if (allResults[i] && allResults[i].status === 200 && allResults[i].data !== null) {
            const rawData = allResults[i].data;
            const isBlob = rawData instanceof Blob || (rawData && rawData.size !== undefined);
            
            if (isBlob) {
              // สแกนตรวจสอบเนื้อไฟล์จริง (Magic Numbers) ของไฟล์ดิบชิ้นนี้
              const textHead = await rawData.slice(0, 4).text();
              let cleanBlob;
              let fileType;

              if (textHead === "%PDF") {
                cleanBlob = new Blob([rawData], { type: 'application/pdf' });
                fileType = 'application/pdf';
              } else if (textHead.startsWith("PK")) {
                cleanBlob = new Blob([rawData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              } else {
                // 🖼️ สลัดหัวดาวน์โหลดทิ้ง บังคับครอบหัวภาพใหม่ให้สะอาด 100% บนหน้าบ้าน
                cleanBlob = new Blob([rawData], { type: 'image/jpeg' });
                fileType = 'image/jpeg';
              }

              const dataUrl = URL.createObjectURL(cleanBlob);
              const originalItem = validFiles[i];

              images.value.push({
                src: dataUrl,
                thumbnailImageSrc: dataUrl,
                alt: '',
                title: fileType, 
                filename: 'attachment_' + originalItem.imageUid, 
                uid: originalItem.uid,
                imageUid: originalItem.imageUid,
                rawBlob: cleanBlob 
              });
            }
          }
        }
      }
    } catch (e) {
      console.error("Error inside Promise.all in getTicketImaged:", e);
      loading.value = false;
      return;
    }
  }

  // 🟢 4. แยกเส้นทางการพรีวิวและดาวน์โหลดตามประเภทไฟล์จริง (หยิบตัวแรกมาตัดสินใจ)
  if (images.value.length > 0) {
    const targetFile = images.value[0];
    const fileType = targetFile.title || "";
    const fileSrc = targetFile.src || "";

    if (fileType === 'application/pdf') {
      // 📄 กรณีเป็น PDF -> ดีดเปิดแท็บใหม่ทันที
      loading.value = false;
      window.open(fileSrc, '_blank');

    } else if (fileType.includes('spreadsheetml') || fileType.includes('excel')) {
      // 📊 กรณีเป็น Excel -> สั่งดาวน์โหลดลงเครื่องทันทีพร้อมชื่อที่สั้นและอ่านง่าย
      loading.value = false;
      let today = moment(new Date()).local().format('YYYYMMDD_HHmmss');
      let fileNameDownload = `excel_${today}.xlsx`;
      
      const link = document.createElement('a');
      link.href = fileSrc;
      link.setAttribute('download', fileNameDownload);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } else {
      // 🖼️ กรณีเป็นรูปภาพปกติ -> ปิด Loading เพื่อปล่อยให้ฟังก์ชันตัวนอกสั่งเปิด Modal ตามฟลูเดิมของคุณ
      loading.value = false;
    }

  } else {
    // 🟢 5. แผนสำรอง: กรณีไม่มีไฟล์แนบค้างอยู่จริง ให้สวมภาพ noImg แทนที่ตามลอจิกดั้งเดิม
    images.value.push({
      src: noImg,
      thumbnailImageSrc: noImg,
      alt: '',
      title: ''
    });
    loading.value = false;
  }
}


async function getworkCaseInfo(refNumber) {
  const key = detailShopKey();
  let data = "";
  data = {
    refNumber: refNumber,
    groupUid: key.groupUid,
    shopUid: key.uid,
  };
  const payload = data;
  // console.log("workCaseInfo p : " + JSON.stringify(payload));
  const response = await storewc.workCaseInfoByRefFetch(payload);
  // console.log("getworkCaseInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail.value = response.data.data
      }
    }
  }
}


async function getworkCaseInfoPrv(prevRefNumber) {
  const key = detailShopKey();
  let workcase_prv = null
  let data = "";
  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
    refNumber: prevRefNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  //  console.log("workCaseInfoByRef : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcase_prv = response.data.data
        bf_changename.value = workcase_prv.tkCustomerInfo.name 
        transdate_prv.value = workcase_prv.workItems[0].startTime
      }
    }
  }
}


async function getDepositInfo(tkRef) {
  const key = detailShopKey();
  let data = "";
  data = {
    index: 0,
    size: 1,
    groupUid: key.groupUid,
    shopUid: key.uid,
    cusUid: '',
    refNumber: '',
    tkRefNumber: tkRef.trim(),
    channel: '',
    txDate: 0,
  };
  const payload = data;
  // console.log("ld p : " + JSON.stringify(payload));
  const response = await storedepo.listDepositFetch(payload);
  // console.log("ld r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list
        dep_ref.value = listd[0].refNumber
      }
    }
  }
}

async function retrieveInfo(item) {
  promotionDetail.value = null
  let data = "";
  let pawnValue = 0
  if (item.transactionType != 'REDEEM') {
      pawnValue = item.newPawnValue
  } else {
      pawnValue = item.pawnValue
  }

  let cusUid = item.customerInfo.customerUid

  if(item.represent || item.shopRepresent){
     cusUid =  item.tkCustomerInfo.customerUid 
  }

  data = {
    cusUid : cusUid,
    pawnDate: moment(item.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    pawnValue: pawnValue,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestRetrieveFetch(payload);
  // console.log("retrieveInfo r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        const result = res.interests.flatMap(item => {
        // เงื่อนไข: เป็นโปรโมชัน และ periodMonths > 1
        if (item.promotion === true && item.periodMonths > 1) {
          // สร้าง Array ใหม่ที่มีจำนวน element เท่ากับ periodMonths และใส่ข้อมูล item ลงไป
          return Array.from({ length: item.periodMonths }, () => ({ ...item }));
        }
        // หากไม่ตรงเงื่อนไข ให้คืนค่าเดิมกลับไป 1 ชุด
        return [item];
        });
        // console.log('result : ' + JSON.stringify(result));
      res.interests  =  result
      promotionDetail.value = res
      // console.log('promotionDetail : ' + JSON.stringify(promotionDetail.value));
      }
    }
  }
}


async function calIntInt() {
  // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value));
  let postponeDate = ''
  if (workcaseDetail.value.postponeCount != 0) {
    postponeDate = moment(workcaseDetail.value.postponeDate).format('YYYY-MM-DD')
  }
  let data = "";
  let pawnValue = 0
  if (workcaseDetail.value.transactionType != 'REDEEM') {
    pawnValue = workcaseDetail.value.newPawnValue
  } else {
    pawnValue = workcaseDetail.value.pawnValue
  }

  let cusUid = workcaseDetail.value.customerInfo.customerUid

  if(workcaseDetail.value.represent || workcaseDetail.value.shopRepresent){
     cusUid =  workcaseDetail.value.tkCustomerInfo.customerUid 
  }
  data = {
    cusUid: cusUid,
    txType: workcaseDetail.value.transactionType,
    pawnDate: moment(workcaseDetail.value.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    postponeDate: postponeDate,
    pawnValue: pawnValue,
    promotionUid: workcaseDetail.value.promotionUid,
    interestUid: workcaseDetail.value.interestUid,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestCalculateFetch(payload);
  // console.log("calIntInt r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
      }
    }
  }
}


async function detailPayment(item) {
  const key = detailShopKey();
  let data = "";
  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
    uid: item,
  };
  const payload = data;
  const response = await storep.paymentGroupInfoAdminFetch(payload);
  // console.log("detailPayment : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        paymentE.value = response.data.data
        filterPayType()
        // console.log('detailPayment : ' + JSON.stringify(paymentE.value));
      }
    }
  }
}


function filterPayType() {
  payment_l.value = []
  let pt = [{ name: 'CASH' },
  { name: 'BANK_TRANSFER' },
  { name: 'CREDIT_CARD' },
  { name: 'CHEQUE' },
  { name: 'PROMPT_PAY_MOBILE' },
  { name: 'PROMPT_PAY_TAX_ID' },
  { name: 'QR_CODE' },
  ]
  let lsum = []
  for (let i = 0; i < pt.length; i++) {
    lsum = filterSumPay(pt[i].name)
    if (lsum.length > 0) {
      payment_l.value.push({ name: pt[i].name, pay: lsum[0].pay, receive: lsum[0].receive, fee: lsum[0].fee })
    } else {
      payment_l.value.push({ name: pt[i].name, pay: 0, receive: 0, fee: 0 })
    }
  }
}

function filterSumPay(str) {
  let nump = 0, numr = 0, numf = 0
  let lp = paymentE.value.payments.filter((c) => c.type === str);
  if (lp.length > 0) {
    let pay = 0
    let receive = 0
    let fee = 0
    for (let i = 0; i < lp.length; i++) {
      pay = pay + lp[i].pay
      receive = receive + lp[i].receive
      fee = fee + lp[i].feeReceive
      // fee = fee + lp[i].fee
    }
    nump = pay
    numr = receive
    numf = fee
  }
  let lockL = []
  lockL.push({ pay: nump, receive: numr, fee: numf })
  // console.log('lockL : ' + JSON.stringify(lockL));
  return lockL
}


function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm')
  }
}

function format_date(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY')
  }
}

async function searchCustomer(item) {
  // console.log('cusUid : ' + item.cusUid)
  await clearCustomer()
  let data = "";
  data = {
    uid: item.cusUid,
  };

  const payload = data;
  const response = await storecuss.cusShopInfoByCusUidFetch(payload);
  // console.log("CusshopInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        if (response.data.data !== null) {
          cusShop.value = response.data.data
          cusShop.value.cusName = item.cusName
          await getCustomerLineInfo(cusShop.value.cusUid)
          document.getElementById("exampleModalShow").click();
        }
      }
    }
  }
}

async function getCustomerLineInfo(uid) {
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  displayName.value = ''
  let data = "";
  data = {
    index: 0,
    size: 10,
    groupUid: key.groupUid,
    shopUid: key.uid,
    cusUid: uid,
  };

  const payload = data;
  // console.log("CustomerInfo p : " + JSON.stringify(payload));
  const response = await storecusline.cusLineListFetch(payload);
  // console.log("CustomerInfo r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let list = response.data.data.list
        if (list.length > 0) {
          displayName.value = response.data.data.list[0].displayName
        }
      }
    }
  }
}

async function clearCustomer() {
  cusShop.value = {
    uid: '',
    cusUid: "",
    shopUid: "",
    cusTypeUid: "0",
    interestUid: "no",
    openAccountDate: null,
    lastActiveDate: null,
    phoneNo1: "",
    phoneNo2: "",
    phoneNo3: "",
    signature1Uid: "0",
    signature2Uid: "0",
    fingerPrint1Uid: "0",
    fingerPrint2Uid: "0",
    fgTemplate1Uid: "0",
    fgTemplate2Uid: "0",
    email: "",
    warningMsg: "",
    notifyWarning: false,
    creditAmount: 0,
    version: '',
    cusName: "",
  }
}

onMounted(() => {
  workflowNow.value = Date.now();
  workflowAgeTimer = setInterval(() => {
    workflowNow.value = Date.now();
  }, 60000);

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.add('show', 'active')
  }
});

onBeforeUnmount(() => {
  if (workflowAgeTimer) {
    clearInterval(workflowAgeTimer);
    workflowAgeTimer = null;
  }
});


</script>

<style lang="scss" scoped>

.dashboard-tabs {
  flex-wrap: nowrap;
  gap: 4px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;

  .nav-item {
    flex: 0 0 auto;
  }

  .nav-link {
    min-height: 44px;
    padding: 10px 20px;
    border-radius: 6px 6px 0 0;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5;
    white-space: nowrap;
    transition: color 0.18s ease, background-color 0.18s ease,
      border-color 0.18s ease;

    &:hover:not(.active):not(:disabled) {
      color: #fff;
      background-color: var(--bs-secondary, #05602d);
      border-color: var(--bs-secondary, #05602d);
    }

    &:focus-visible {
      outline: 3px solid rgba(5, 175, 80, 0.22);
      outline-offset: 2px;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.68;
    }
  }
}

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ───── การ์ดบนสุด : แบ่งส่วน ทั้งระบบ / ตามช่วงวันที่ ───── */
.stat-section-head {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

/* tile พื้นเทาขอบบนสี (แบบเดิม) — จัด layout เป็น grid:
   แถวบน label เต็มความกว้าง / แถวล่าง icon อยู่หน้าตัวเลข */
.stat-tile {
  height: 100%;
  background: #f8f9fa;
  border-radius: 12px;
  padding: 14px 10px;
  display: grid;
  grid-template-columns: auto auto;
  grid-template-areas:
    "label label"
    "ico value";
  justify-content: center;
  justify-items: center;
  align-items: center;
  column-gap: 10px;
  row-gap: 6px;
  text-align: center;
}

/* ดัน label/value ที่ซ้อนอยู่ใน .stat-info ขึ้นมาเป็นลูกของ grid โดยตรง */
.stat-info {
  display: contents;
}

.stat-label {
  grid-area: label;
}

/* กล่องไอคอนสีพื้นจาง อยู่หน้าตัวเลข */
.stat-ico {
  grid-area: ico;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i {
    font-size: 20px;
  }
}

.stat-value {
  grid-area: value;
}

.tile-system {
  border-top: 3px solid #0d9488;

  /* section ภาพรวมทั้งระบบ ใช้ font ใหญ่กว่าปกติ */
  .stat-label {
    font-size: 16px;
  }

  .stat-value {
    font-size: 33px;
  }
}

.tile-period {
  border-top: 3px solid #4f46e5;

  /* ไม่มี icon — เลิกใช้ grid ของ .stat-tile แล้วเรียงแนวตั้งกึ่งกลางแทน */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;

  /* ใหญ่ขึ้นจากค่าปกติเล็กน้อย (แต่ยังเล็กกว่า section ภาพรวมทั้งระบบ) */
  .stat-label {
    font-size: 14px;
  }

  .stat-value {
    font-size: 27px;
  }
}

.stat-label {
  font-size: 13px;
  font-weight: 600;
  color: #67748e;
  line-height: 1.4;
}

.stat-value {
  font-size: 24px;
  line-height: 1.2;
}

/* ───── Donut ข้อมูลสำหรับระบบเก่า : ยอดรวมตรงกลาง ───── */
/* ขนาดตายตัว — เดิมกรอบกว้างเต็มคอลัมน์และสูงตาม default ของ Chart.js
   (ครึ่งหนึ่งของความกว้าง) วงจึงหดตามจอ แต่ตัวเลขกลางไม่หดตาม → ล้นรู donut */
.oldsys-donut-wrap {
  position: relative;
  width: 220px;
  height: 220px;
  margin: 0 auto;
}

.oldsys-donut-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  pointer-events: none;

  span {
    font-size: 14px;
    font-weight: 600;
    color: #67748e;
    line-height: 1.25;
    // กว้างไม่เกินรู donut (62% ของ 220px ≈ 136px) — ชื่อยาวขึ้นบรรทัดใหม่แทนล้น
    max-width: 110px;
  }

  b {
    font-size: 22px;
    color: #344767;
    line-height: 1.2;
  }
}

/* จุดสีใน legend (ใช้คู่กับ class สีกลาง bg-pledge ฯลฯ) */
.legend-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 6px;
  vertical-align: middle;
  flex-shrink: 0;
}

/* ───── Tab รายละเอียด : Security Check bar ───── */
.detail-security-bar {
  display: flex;
  height: 56px;
  border-radius: 10px;
  overflow: hidden;

  .detail-security-seg {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    min-width: 0;
    padding: 0 6px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);

    .seg-label {
      font-size: 12px;
      font-weight: 600;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }

    .seg-pct {
      font-size: 13px;
      font-weight: 700;
    }
  }
}

.detail-security-legend {
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
  margin-top: 10px;
  font-size: 12px;

  span {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  i {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 3px;
  }
}



/* นำ Font Awesome มาใช้สำหรับไอคอน */
@import url('https://cdnjs.cloudflare.com');
@import url('https://fonts.googleapis.com');



.dashboard-container {
  display: flex;
  gap: 16px;
  padding: 20px;
  flex-wrap: wrap;
  /* ไม่ override font — ใช้ font เดียวกับทั้งหน้า dashboard ($font-family-sans-serif) */
}


.dashboard-containerd {
  display: flex;
  gap: 16px;
  padding: 20px;
  flex-wrap: wrap;
  font-family: 'Sarabun', sans-serif; /* แนะนำให้ใช้ฟอนต์ไทย */
}


.card-d {
  background: #fff;
  border: 1px solid #eef0f4;
  border-left: 4px solid #cbd5e1; /* แถบสีซ้าย — สีจริงกำหนดตามประเภทด้านล่าง */
  border-radius: 12px;
  padding: 16px 20px;
  min-width: 260px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 10px rgba(26, 34, 51, 0.06);
  flex: 1;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.card-d:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(26, 34, 51, 0.1);
}

/* ไอคอนในกล่องสีพื้นจาง */
.icon-section {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  margin-right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  flex-shrink: 0;

  i {
    font-size: 28px;
  }
}

.data-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.label {
  font-size: 17px;
  font-weight: 600;
  color: #67748e;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

/* สถานะ (เพิ่มขึ้น/ลดลง) ใน label แสดงเป็น badge เม็ดเล็ก */
.label .text-success,
.label .text-danger {
  font-size: 14px;
  font-weight: 700;
  padding: 1px 10px;
  border-radius: 99px;
}

.label .text-success {
  background: #f0fdf4;
}

.label .text-danger {
  background: #fef2f2;
}

.value {
  font-size: 32px;
  font-weight: 800;
  line-height: 1.25;
  margin-bottom: 0;
}

.unit {
  font-size: 16px;
  font-weight: 600;
  color: #8a93ab;
  margin-left: 4px;
}

.sub-text {
  font-size: 16px;
  color: #8a93ab;
}

/* สีแยกตามสถานะ — แถบซ้าย + กล่องไอคอน + ตัวเลข (โทนเดียวกับ palette ใหม่) */
.pawn-in { border-left-color: #3b82f6; }
.pawn-in .value { color: #2563eb; }
.pawn-in .icon-section { color: #2563eb; background: #eff6ff; }

.pawn-out { border-left-color: #f43f5e; }
.pawn-out .value { color: #e11d48; }
.pawn-out .icon-section { color: #e11d48; background: #fff1f2; }

.interest { border-left-color: #f59e0b; }
.interest .value { color: #d97706; }
.interest .icon-section { color: #d97706; background: #fffbeb; }

.net-cash { border-left-color: #10b981; }
.net-cash .value { color: #344767; }
.net-cash .icon-section { color: #059669; background: #ecfdf5; }

/* Responsive */
@media (max-width: 768px) {
  .card {
    min-width: 100%;
  }
}

/* สีเขียวเมื่อค่าเป็นบวก (>= 0) */
.text-success {
  color: #15803d !important;
  font-weight: bold;
}

/* สีแดงเมื่อค่าติดลบ (< 0) */
.text-danger {
  color: #e53e3e !important;
  font-weight: bold;
}


/* คอนเทนเนอร์หลัก */
.summary-row {
  width: 100%;
}

.summary-card {
  flex: 1; /* ให้แต่ละกล่องกว้างเท่ากัน */
  padding: 12px 20px;
  border-radius: 10px;
  //border-left: 5px solid; /* เส้นหนาด้านซ้ายเพื่อความสวยงาม */
  border: 5px solid;
  transition: transform 0.2s;
  background: #ffffff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
}

.label {
  font-size: 0.9rem;
  color: #5c6b7a;
  font-weight: 500;
}

.value {
  font-size: 1.25rem;
  font-weight: 800;
  margin-left: 15px;
}

/* --- การกำหนดสีตามประเภท --- */

/* สีน้ำเงิน - จำนวนตั๋ว */
.color-blue {
  background-color: #f0f7ff;
  // border-left-color: #4A90E2;
  border-color: #4A90E2;
}
.color-blue .value { color: #4A90E2; }

/* สีเขียว - จำนวนลูกค้า */
.color-green {
  background-color: #f2faf3;
  // border-left-color: #66BB6A;
  border-color: #66BB6A;
}
.color-green .value { color: #66BB6A; }

/* สีแดง/ชมพู - ผู้มีอำนาจ */
.color-red {
  background-color: #fff5f5;
  // border-left-color: #EF5350;
  border-color: #EF5350;
}
.color-red .value { color: #EF5350; }

/* ป้องกันตัวอักษรตกบรรทัดในจอเล็ก */
@media (max-width: 991px) {
  .d-flex {
    flex-direction: column;
  }
  .summary-card {
    width: 100%;
  }
}

/* เส้นขอบหนาด้านบน เมื่อเริ่มกลุ่มใหม่ */
.group-start {
  border-top: 2px solid #444 !important;
}

/* เส้นขอบหนาด้านล่าง เมื่อจบกลุ่ม (หรือจบตาราง) */
.group-end {
  border-bottom: 2px solid #444 !important;
}

/* ตกแต่งคอลัมน์ Channel ให้ดูเป็นระเบียบ */
.channel-cell {
  background-color: #fcfcfc;
  border-right: 1px solid #dee2e6;
  vertical-align: middle; /* ให้ชื่อกลุ่มอยู่กึ่งกลางแนวตั้ง */
}

/* เส้นแบ่งคอลัมน์แนวตั้งให้ชัดเจน */
.border-left {
  border-left: 1px solid #dee2e6;
}

.workflow-dashboard-card {
  overflow: hidden;
}

.workflow-total-card,
.workflow-stat-card,
.workflow-flow-map,
.workflow-detail-panel {
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.04);
}

.workflow-total-card {
  position: relative;
  min-height: 132px;
  padding: 18px;
  overflow: hidden;
}


.workflow-kicker,
.workflow-stat-card span {
  display: block;
  color: #67748e;
  font-size: 0.78rem;
  font-weight: 700;
}

.workflow-total {
  margin-top: 8px;
  color: #11845b;
  font-size: 3.2rem;
  font-weight: 800;
  line-height: 1;
}

.workflow-total span {
  color: #67748e;
  font-size: 1rem;
  font-weight: 700;
}

.workflow-stat-card {
  min-height: 132px;
  padding: 18px;
}

.workflow-stat-card strong {
  display: block;
  margin-top: 12px;
  color: #344767;
  font-size: 2rem;
  font-weight: 800;
  line-height: 1;
}

.workflow-stat-warning strong {
  color: #e53e3e;
  animation: workflowPulse 1.8s ease-in-out infinite;
}

.workflow-flow-map {
  padding: 16px;
}

.workflow-flow-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.workflow-flow-step {
  position: relative;
  min-height: 112px;
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  background: #f8f9fa;
  padding: 14px;
  overflow: hidden;
  animation: workflowRiseIn 0.45s ease both;
}

.workflow-flow-step::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--workflow-accent);
}

.workflow-queue-code,
.workflow-detail-chip {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  border-radius: 999px;
  padding: 0 10px;
  background: rgba(52, 71, 103, 0.08);
  color: var(--workflow-accent);
  font-size: 0.75rem;
  font-weight: 800;
}

.workflow-queue-name {
  margin-top: 10px;
  color: #344767;
  font-weight: 800;
}

.workflow-queue-cash {
  margin-top: 8px;
  display: flex;
  align-items: baseline;
  gap: 5px;
  font-size: 12px;

  strong {
    font-size: 14px;
    font-weight: 800;
  }

  &.wf-net-receive {
    color: #276749;
    strong { color: #276749; }
  }

  &.wf-net-payout {
    color: #c53030;
    strong { color: #c53030; }
  }
}

.workflow-queue-total {
  margin-top: 8px;
  color: var(--workflow-accent);
  font-size: 1.85rem;
  font-weight: 800;
  line-height: 1;
}

.workflow-queue-total span {
  color: #67748e;
  font-size: 0.85rem;
  font-weight: 700;
}

.workflow-search-input {
  flex: 1 1 auto;
  min-width: 0;
  border: 1px solid #d2d6da;
  border-radius: 0.375rem;
  padding: 0.625rem 0.75rem;
  line-height: 1.3;
  background: none;
  font-size: 1rem;
  color: #495057;
  outline: none;
  transition: border-color 0.15s ease-in-out;
}

.workflow-search-input:focus {
  border-color: #11845b;
}

.workflow-search-input::placeholder {
  color: #adb5bd;
}

.workflow-filter-group {
  display: flex;
  gap: 6px;
  align-items: center;
  padding: 4px;
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  background: #fff;
  flex-shrink: 0;
}

.workflow-filter-group button {
  min-width: 96px;
  height: 32px;
  border: 0;
  border-radius: 0.35rem;
  background: transparent;
  color: #67748e;
  font-weight: 700;
}

.workflow-filter-group button.active {
  background: #05af50;
  color: #fff;
}

.workflow-board {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 4px;
}

.workflow-lane {
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  background: #f8f9fa;
  padding: 10px;
}

.workflow-lane-body {
  max-height: 1000px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 2px;
}

.workflow-lane-body::-webkit-scrollbar {
  width: 4px;
}

.workflow-lane-body::-webkit-scrollbar-track {
  background: transparent;
}

.workflow-lane-body::-webkit-scrollbar-thumb {
  background: #dee2e6;
  border-radius: 4px;
}

.workflow-lane-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  color: #344767;
  font-weight: 800;
}

.workflow-lane-header b {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 24px;
  border-radius: 999px;
  background: #fff;
  color: var(--workflow-accent);
}

.workflow-item-card {
  width: 100%;
  margin-bottom: 9px;
  padding: 11px;
  border: 1px solid #e9ecef;
  border-left: 4px solid var(--workflow-accent);
  border-radius: 0.5rem;
  background: #fff; /* overridden by inline :style per transaction type */
  text-align: left;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  animation: workflowCardIn 0.32s ease both;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.workflow-item-card:hover,
.workflow-item-card.selected {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(52, 71, 103, 0.14);
  border-color: var(--workflow-accent);
}

.workflow-item-card:focus-visible {
  outline: 2px solid var(--workflow-accent);
  outline-offset: 2px;
}

.workflow-job-id,
.workflow-age,
.workflow-card-meta,
.workflow-desc,
.workflow-cash-value,
.workflow-card-footer,
.workflow-empty-lane {
  font-size: 0.78rem;
}

.workflow-job-id {
  color: #344767;
  font-weight: 800;
}

.workflow-age {
  color: #67748e;
  font-weight: 700;
  white-space: nowrap;
}

.workflow-age.waiting {
  color: #e53e3e;
  animation: workflowPulse 1.8s ease-in-out infinite;
}

.workflow-customer {
  margin-top: 8px;
  color: #344767;
  font-size: 0.95rem;
  font-weight: 800;
  line-height: 1.35;
}

.workflow-card-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 4px;
}

.workflow-desc {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #67748e;
  line-height: 1.4;
}

.workflow-cash-value {
  flex-shrink: 0;
  font-weight: 800;
  white-space: nowrap;
}

.workflow-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding-top: 9px;
  border-top: 1px solid #f0f2f5;
  color: #344767;
  font-weight: 700;
}

.workflow-owner {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.workflow-card-actions {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.workflow-card-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  background: #fff;
  color: #67748e;
  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.workflow-card-action i {
  font-size: 17px;
  line-height: 1;
}

.workflow-card-action:hover:not(:disabled) {
  border-color: var(--workflow-accent);
  background: rgba(52, 71, 103, 0.05);
  color: var(--workflow-accent);
}

.workflow-card-action:disabled {
  cursor: not-allowed;
  opacity: 0.35;
}

.workflow-card-action-coll:not(:disabled) {
  color: #0e7490;
}

.workflow-card-action-img:not(:disabled) {
  color: #11845b;
}

.workflow-cash-pay {
  color: #e53e3e;
}

.workflow-cash-receive {
  color: #11845b;
}

.workflow-empty-lane {
  padding: 26px 8px;
  color: #67748e;
  text-align: center;
  font-weight: 700;
}

.workflow-detail-panel {
  position: sticky;
  top: 16px;
  overflow: hidden;
}

.workflow-detail-header {
  padding: 16px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}

.workflow-detail-body {
  display: grid;
  gap: 12px;
  padding: 16px;
  animation: workflowDetailSlide 0.28s ease both;
}

.workflow-detail-summary {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background: #f8f9fa;
}

.workflow-detail-summary > div {
  display: grid;
  gap: 4px;
  min-width: 0;
}

.workflow-detail-row {
  display: grid;
  gap: 3px;
}

.workflow-detail-label,
.workflow-detail-row > span {
  color: #67748e;
  font-size: 0.78rem;
  font-weight: 800;
}

.workflow-detail-summary strong {
  color: #344767;
  font-size: 1.05rem;
  line-height: 1.3;
}

.workflow-detail-summary small {
  color: #67748e;
  font-weight: 700;
  line-height: 1.35;
}

.workflow-detail-queue-badge {
  flex-shrink: 0;
  padding: 5px 9px;
  border-radius: 999px;
  color: #fff;
  font-size: 0.76rem;
  font-weight: 900;
  box-shadow: 0 6px 14px rgba(52, 71, 103, 0.15);
}

.workflow-detail-section {
  display: grid;
  gap: 10px;
  padding: 14px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
}

.workflow-detail-section-title {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #344767;
  font-size: 0.85rem;
  font-weight: 900;
}

.workflow-detail-section-title i {
  color: #67748e;
  font-size: 18px;
}

.workflow-detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 14px;
}

.workflow-detail-row b {
  color: #344767;
  line-height: 1.45;
}

.workflow-detail-row b small {
  display: block;
  margin-top: 2px;
  font-size: 0.74rem;
  font-weight: 800;
}

.workflow-detail-value-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.workflow-detail-value-grid.single {
  grid-template-columns: minmax(0, 1fr);
}

.workflow-detail-value-card {
  display: grid;
  gap: 2px;
  min-height: 78px;
  padding: 12px;
  border-radius: 8px;
  background: #f8f9fa;
}

.workflow-detail-value-card span,
.workflow-detail-value-card small {
  color: #67748e;
  font-size: 0.76rem;
  font-weight: 800;
}

.workflow-detail-value-card .workflow-detail-cash-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.workflow-detail-value-card strong {
  color: #344767;
  font-size: 1.2rem;
  line-height: 1.25;
}

.workflow-detail-value-card strong.workflow-cash-receive {
  color: #11845b;
}

.workflow-detail-value-card strong.workflow-cash-pay {
  color: #e53e3e;
}

.workflow-payment-detail-list {
  min-height: 24px;
}

.workflow-detail-muted {
  color: #67748e;
  font-weight: 800;
}

.workflow-detail-row--full {
  grid-column: 1 / -1;
}

.workflow-workcases {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
  max-height: 220px;
  overflow-y: auto;
  padding-right: 2px;
}

.workflow-workcase-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 0.78rem;
  font-weight: 700;
  white-space: nowrap;
}

.workflow-workcase-chip small {
  font-weight: 500;
  font-size: 0.72rem;
  opacity: 0.85;
}

.workflow-payment-types {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 6px;
}

.workflow-payment-type-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  background: rgba(52, 71, 103, 0.08);
  color: #344767;
  font-size: 0.75rem;
  font-weight: 800;
}

.workflow-payment-type-amount {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.workflow-payment-type-receive {
  color: #11845b;
}

.workflow-payment-type-pay {
  color: #e53e3e;
}

.workflow-payment-type-fee,
.workflow-payment-type-empty,
.workflow-payment-type-separator {
  color: #67748e;
}

.workflow-detail-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 0 16px 16px;
}


@keyframes workflowRiseIn {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes workflowCardIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes workflowPulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.55;
  }
}

@keyframes workflowDetailSlide {
  from {
    opacity: 0;
    transform: translateX(10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 1199px) {
  .workflow-detail-panel {
    position: static;
  }
}

@media (max-width: 991px) {
  .workflow-flow-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .workflow-board {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

}

@media (max-width: 575px) {
  .workflow-flow-grid {
    grid-template-columns: 1fr;
  }

  .workflow-detail-summary {
    display: grid;
  }

  .workflow-detail-grid,
  .workflow-detail-value-grid,
  .workflow-detail-value-grid.single {
    grid-template-columns: 1fr;
  }

  .workflow-detail-actions {
    grid-template-columns: 1fr;
  }

  .workflow-board {
    grid-template-columns: 1fr;
  }
}

/* ── Payment Cashflow Summary ─────────────────────────── */
.workflow-cashflow-card {
  border-radius: 12px;
  padding: 16px;
  height: 100%;
  border: 1.5px solid transparent;

  &.workflow-cashflow-payout {
    background: #fff5f5;
    border-color: #fecaca;
  }

  &.workflow-cashflow-receive {
    background: #f0fdf4;
    border-color: #bbf7d0;
  }
}

.workflow-cashflow-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #4a5568;

  .workflow-cashflow-payout & { color: #c53030; }
  .workflow-cashflow-receive & { color: #276749; }

  .material-icons { font-size: 18px; }
}

.workflow-cashflow-badge {
  margin-left: auto;
  font-size: 11px;
  font-weight: 600;
  color: #4a5568;
  background: rgba(0, 0, 0, 0.07);
  padding: 2px 8px;
  border-radius: 20px;
}

.workflow-cashflow-total {
  font-size: 24px;
  font-weight: 800;
  letter-spacing: -0.5px;
  margin-bottom: 10px;

  &.wf-payout  { color: #c53030; }
  &.wf-receive { color: #276749; }

  span {
    font-size: 13px;
    font-weight: 500;
    color: #67748e;
    margin-left: 3px;
  }
}

.workflow-cashflow-methods {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  padding-top: 8px;
  margin-top: 8px;
}

.workflow-cashflow-method-row {
  display: flex;
  align-items: center;
  padding: 4px 0;
  font-size: 13px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);

  &:last-child { border-bottom: none; }
}

.workflow-cashflow-method-label {
  flex: 1;
  color: #2d3748;
}

.workflow-cashflow-method-amt {
  min-width: 90px;
  text-align: right;
  font-size: 13px;

  &.wf-payout  { color: #c53030; }
  &.wf-receive { color: #276749; }
}

.workflow-cashflow-note {
  font-size: 11px;
  color: #a0aec0;
  margin-top: 6px;
}

</style>
